import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages: {[key: string]: any} = {
  th: {
    play: 'เข้าเล่น',
    deposit: 'ฝากเงิน',
    withdraw: 'ถอนเงิน',
    error: 'ผิดพลาด',
    loading: 'กำลังโหลด...',
    welcome_message: 'ยินดีต้อนรับสู่ funbeyond โลกแห่งการเดิมพันที่ดีที่สุด',
    system_title: 'ระบบ Casino ที่ดีที่สุด มีแบรนด์ให้เลือกเล่นมากมาย',
    alt_play_skill: 'สุ่มเล่นสกิลเกมบนเว็บ funbeyond คาสิโน บาคาร่าสดออนไลน์',
    alt_lottery: 'แทงหวย funbeyond คาสิโน บาคาร่าสดออนไลน์',
    alt_gashapon: 'กาชาปอง Funbeyond คาสิโน บาคาร่าสดออนไลน์',
    alt_reward: 'แลกของรางวัล Funbeyond คาสิโน บาคาร่าสดออนไลน์',
    img_title: 'funbeyond ศูนย์รวมแบรนด์ชั้นยอด อันดับ 1',
    withdraw_amount: 'จำนวนเงินที่ต้องการถอน',
    withdraw_min: '- ถอนขั้นต่ำ {min} /ครั้ง',
    withdraw_min_max: '- ถอนขั้นต่ำ {min} สูงสุด {max} /ครั้ง',
    withdraw_daily_limit: '- สูงสุด {max} และ {qtyperday} ครั้ง/วัน',
    withdraw_bank_close: '{detail}',
    withdraw_bank_close_default: '- ระบบธนาคารปิดปรับปรุง โปรดเลี่ยงการแจ้งถอนในช่วงเวลา <br>23:50-00:10น.',
    withdraw_to_bank: 'เข้าบัญชีนี้',
    withdraw_modal: {
      title: 'ทำรายการถอน',
      error_title: 'Error!',
      max_daily_count: 'ขออภัยท่านทำรายการถอนครบ {count} ครั้ง ทำรายการได้อีกครั้งหลังเที่ยงคืนนะคะ',
      max_daily_amount: 'ไม่สามารถดำเนินการถอนได้ ท่านสามารถทำการถอนได้สูงสุด {amount} บาท/วัน รบกวนทำการแจ้งถอนใหม่นะคะ',
      check_credit_condition: 'โปรดตรวจสอบจำนวนเครดิตและเงื่อนไขการถอน',
      truewallet_amount_invalid: 'สำหรับ TrueMoney Wallet ยอดถอนขั้นต่ำ 100 บาท และต้องลงท้ายด้วย 0 เท่านั้น (เช่น 110, 150, 200)'
    },
    deposit_account: 'กรุณาใช้เลขบัญชีที่สมัครโอนเข้ามาเท่านั้น',
    deposit_promotion: 'หากต้องการรับโปร โปรดกดรับโปรทุกครั้งก่อนโอนเงินนะคะ',
    deposit_promotion2: 'รับโปรโมชั่น',
    deposit_promotion3: 'ไม่รับโปรโมชั่น',
    deposit_slip: 'หากเงินไม่เข้าภายใน 5 นาที อัพโหลดสลิปที่นี่!!',
    deposit_amount: 'จำนวนเงินที่ต้องการฝาก',
    specify_deposit_amount: 'ระบุจำนวนเงินที่ต้องการฝาก',
    deposit_instruction: 'พิมพ์ใส่ยอดที่ต้องการฝากหรือกดเลือกยอดตามที่แสดงได้เลยค่ะ',
    confirm_deposit: 'ยืนยันการฝาก',
    deposit_promptpay: 'แจ้งฝากพร้อมเพย์',
    select_bank: 'เลือกธนาคาร',
    phone_number: 'เบอร์โทร',
    account_number: 'เลขที่บัญชี',
    add_bank_before_withdraw: 'กรุณาเพิ่มบัญชีธนาคารในข้อมูลบัญชีก่อนทำการถอน',
    select_withdraw_account: 'เลือกบัญชีปลายทาง:',
    select_account_to_receive: 'เลือกบัญชีที่จะรับเงิน',
    please_select_account: 'กรุณาเลือกบัญชีที่จะรับเงินค่ะ',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    confirm_logout: 'ยืนยันออกจากระบบ',
    copy_success: 'คัดลอกเรียบร้อยแล้ว',
    withdraw_temporarily_closed: 'ปิดการถอนเงิน ชั่วคราวค่ะ',
    withdraw_pending: 'โปรดรอรายการถอนเสร็จเป็นที่เรียบร้อย จึงจะเริ่มทำรายการธุรกรรมอื่นๆต่อไปนะคะ',
    no_bonus_description: 'ไม่รับโบนัส ถอนได้ทันที เพียงมียอดเล่นเท่าที่ฝาก',
    close: 'ปิดหน้าต่าง',
    close_announcement: 'รับทราบแล้ว',
    skip_announcement: 'ข้ามไปก่อน',
    contact_service: `<span class="x-text-with-link-component" style="font-size:15px;font-family: 'Kanit', sans-serif;">
								<label class="-text-message ">ติดปัญหา&nbsp;</label>&nbsp;
								<a href="https://lin.ee/L8YOLQ7" class="-link-message " target="_blank" rel="noopener">
									<u>ติดต่อฝ่ายบริการลูกค้า</u>
								</a>
							</span>`,
    promotion: 'โปรโมชั่น',
    menu_promotion: 'โปรโมชั่น',
    get_promotion: 'รับโปรโมชั่น',
    promotion_terms: 'เงื่อนไขและกติกาพื้นฐานจะถูกนำมาใช้กับโปรโมชั่นนี้',
    partner: 'พันธมิตร',
    cashback: 'คืนยอด',
    title: 'ระบบ Casino ที่ดีที่สุด ส่งตรงจาก Casino ชื่อดังในสิงคโปร์',
    description_deposit: 'ฝาก ไม่รับโบนัส, ถอนได้ทันทีไม่มีเงื่อนไข',
    all_brands: 'แบรนด์ทั้งหมดที่ดีที่สุด รวมอยู่ในที่นี่แล้ว',
    description_all_brands: 'ใช้ได้หมดทุกแบรนด์',
    description_brands: 'ศูนย์รวมแบร์นที่ดีทีสุดและเกมส์คาสิโนทุกเกมส์ไว้ที่นี่ที่เดียว อาทิ UFA IMI และ Betflix เฉพาะครอบครัว FunBeyond เท่านั้น',
    withdraw_all: 'โยกเงินออกทั้งหมด',
    refresh_credit: 'รีเฟรสเครดิตทั้งหมด',
    qty_credit: 'จำนวนเครดิต',
    footer_description: 'คาสิโนชั้นนำ รวมแบรนด์ดัง มีทุกค่าย รับง่าย ถอนไว',
    footer_description2: 'ศูนย์รวมแบรนด์ที่ดีทีสุดและเกมส์คาสิโนทุกเกมส์ไว้ที่นี่ที่เดียว อาทิ UFA IMI AMB และ Betflix เฉพาะครอบครัว Funbeyond เท่านั้น',
    promotion_title: 'โปรโมชัน ที่ Funbeyond มีมากกว่า แตกง่ายกว่า',
    link_partner: 'ลิงก์รับทรัพย์',
    deposit_title: 'ยอดฝาก',
    deposit_title2: 'ยอดเสีย',
    deposit_title3: 'ส่ง Link ได้ทุกช่องทางรับทรัพย์กับเรา',
    copy: 'คัดลอก',
    copy_button: 'คัดลอก',
    // Placeholders
    current_password_placeholder: 'รหัสผ่านปัจจุบัน',
    new_password_placeholder: 'รหัสผ่านใหม่',
    confirm_new_password_placeholder: 'พิมพ์รหัสผ่านใหม่อีกครั้ง',
    amount_baht_placeholder: 'จำนวนเงิน (บาท)',
    // Status messages
    approved_status: 'อนุมัติแล้ว',
    pending_approval_status: 'รอการอนุมัติ',
    loading_status: 'กำลังโหลด...',
    processing_status: 'กำลังประมวลผล...',
    // Button texts
    contact_admin: 'ติดต่อแอดมิน',
    to_this_account: 'เข้าบัญชีนี้',
    confirm_amount: 'ยืนยันจำนวนเงิน',
    close_window: 'ปิดหน้าต่าง',
    cancel_deposit: 'ยกเลิกการฝาก',
    acknowledged: 'รับทราบแล้ว',
    skip_for_now: 'ข้ามไปก่อน',
    // Bank and deposit messages
    select_your_bank: 'เลือกธนาคารของคุณ',
    please_select_bank_for_deposit: 'กรุณาเลือกธนาคารของคุณสำหรับการฝากเงิน',
    amount_to_transfer: 'จำนวนเงินที่ต้องโอน',
    please_transfer_within_10_minutes: 'กรุณาทำรายการก่อน {{deadlineTime}} (now+10 minutes)',
    time_remaining: 'เหลือเวลา',
    deposit_from_this_account_only: '⚠️ ทำรายการฝากจากบัญชีนี้เท่านั้น ⚠️',
    auto_credit_adjustment_warning: 'ระบบปรับเครดิตเข้าอัตโนมัติ จากยอดฝากรวมเลขทศนิยมที่ถูกต้อง <strong><u>กรุณาอย่าปัดเศษ</u></strong>',
    // Promotion texts
    select_receive_promotion: 'เลือกรับโปรโมชั่น',
    no_promotion: 'ไม่รับโปรโมชั่น',
    receive: 'รับ',
    not_receive: 'ไม่รับ',
    baht_unit: 'บาท',
    // Menu and dialog texts
    logout_confirmation: 'ต้องการออกจากระบบ ?',
    login_with_line: 'เข้าสู่ระบบด้วยไลน์',
    use_coupon: 'ใช้คูปอง',
    play_through_app: 'เข้าเล่นผ่านแอพพ์',
    loading_bank_data: 'กำลังโหลดข้อมูลธนาคาร...',
    no_deposit_channel: 'ขณะนี้ไม่มีช่องทางการฝากเงิน',
    bank_closed_service: 'ธนาคารปิดให้บริการในช่วงเวลานี้',
    service_hours: 'เวลาให้บริการ',
    truewallet_24hrs: 'Truewallet: 24 ชั่วโมง',
    try_again: 'ลองใหม่',
    // Skip option with bank name
    skip_use_first_account: 'ข้าม (ใช้บัญชีแรก)',
    // Alt texts for images
    funbeyond_main_alt: 'Funbeyond รวมคาสิโนออนไลน์ บาคาร่าสด สล็อต กีฬา และเครดิตฟรี',
    rewards_exchange_alt: 'PUG888 แลกของรางวัล',
    play_game_alt: 'เข้าเล่น',
    // Promotion texts
    bonus_2_percent_deposit: 'รับเพิ่ม 2% ทุกบิลฝาก',
    // Additional UI texts
    use_first_account: 'ใช้บัญชีแรก',
    no_deposit_channel_available: 'ขณะนี้ไม่มีช่องทางการฝากเงิน',
    bank_closed_now: 'ธนาคารปิดให้บริการในช่วงเวลานี้',
    details: 'รายละเอียด',
    // Promotion terms
    terms: 'เงื่อนไข',
    promotion_terms_title: 'เงื่อนไขการรับโปรโมชั่น',
    promotion_terms_message: 'หากต้องการรับโปร โปรดกดรับโปรทุกครั้งก่อนโอนเงินนะคะ\\n\\n▪️รับโปรได้ เมื่อมีเครดิตต่ำกว่า 5 บาท\\n▪️ทำผิดเงื่อนไขโปร จะถูกดึงโบนัสและยอดที่เล่นได้คืน\\n▪️พบการเดิมพันผิดปกติ ขอระงับยูซและดึงคืนเครดิตทั้งหมด',
    acknowledge: 'รับทราบ',
    acknowledged_status: 'รับทราบแล้ว',
    thai_lang: 'ไทย',
    // PromptPay messages
    promptpay_deposit_title: 'แจ้งฝากพร้อมเพย์',
    amount_must_exceed_300: 'จำนวนเงินต้องมากกว่า 300 บาท',
    promptpay_problem: 'แจ้งฝากพร้อมเพย์มีปัญหา',
    please_contact_admin: 'โปรดติดต่อ admin',
    promptpay_success: 'แจ้งฝากพร้อมเพย์เรียบร้อย',
    // Promotion terms info
    promotion_terms_info: 'ข้อมูลสำคัญสำหรับการรับโปรโมชั่น',
    promotion_term_1: 'รับโปรได้ เมื่อมีเครดิตต่ำกว่า 10 บาท',
    promotion_term_2: 'ทำผิดเงื่อนไขโปร จะถูกดึงโบนัสและยอดที่เล่นได้คืน',
    promotion_term_3: 'พบการเดิมพันผิดปกติ ขอระงับยูซและดึงคืนเครดิตทั้งหมด',
    partner_title: 'รายได้ผู้แนะนำ',
    partner_title2: 'แนะนำเพื่อน',
    partner_title3: 'เพื่อนแนะนำเพื่อน',
    partner_title4: 'รายได้แนะนำเพื่อน',
    partner_title5: 'รายได้เพื่อนแนะนำเพื่อน',
    partner_title6: 'รายได้ทั้งหมด',
    partner_title7: 'โอนเงินเข้ากระเป๋าหลัก',
    table_code: 'รหัส',
    table_date: 'วันที่',
    table_deposit: 'ฝาก',
    table_withdraw: 'ถอน',
    data_summary_yesterday: '*ข้อมูลสรุปยอดเมื่อวาน',
    contact_problem: 'ติดปัญหา',
    contact_customer_service: 'ติดต่อฝ่ายบริการลูกค้า',
    deposit_type: {
      deposit: 'ยอดฝาก',
      loss: 'ยอดเสีย'
    },
    login_page: {
      mobile: 'เบอร์โทรศัพท์',
      forgot_password: 'ลืมรหัสผ่าน ?',
      contact_admin: 'ติดต่อแอดมิน',
      password: 'รหัสผ่าน',
      login_with: 'เข้าสู่ระบบ',
      login_with_line: 'เข้าสู่ระบบด้วยไลน์',
      login_with_facebook: 'เข้าสู่ระบบด้วยเฟสบุ๊ค',
      login_with_google: 'เข้าสู่ระบบด้วย Google',
      no_account: 'หรือยังไม่มีบัญชี',
      register: 'สมัครสมาชิก',
      change_password: 'เปลี่ยนรหัสผ่าน',
      confirm_mobile_account: 'กรุณากรอกเบอร์โทรศัพท์และเลขที่บัญชี',
      account_number: 'เลขที่บัญชี',
      new_password: 'กรุณากรอกรหัสผ่านใหม่',
      new_password2: 'รหัสผ่านใหม่',
      confirm_new_password: 'ยืนยันรหัสผ่านใหม่',
      confirm: 'ยืนยัน',
      please_check_password: 'โปรดตรวจสอบข้อมูลรหัสให้ถูกต้องค่ะ',
      text_header: 'ข้อความ!',
      change_password_success: 'เปลี่ยนรหัสผ่านเรียบร้อยแล้วค่ะ',
      please_fill_data: 'โปรดระบุข้อมูลให้ครบด้วยค่ะ!!!',
      please_contact_admin: 'โปรดติดต่อแอดมิน @funbeyondvip',
      mobile_password_error: 'เบอร์โทรศัพท์ / รหัสผ่าน ไม่ถูกต้องค่ะ!!!',
    },
    register_page: {
      title: 'สมัครสมาชิก',
      verify_otp: 'ยืนยันรหัส OTP',
      register_success: 'การสมัครของคุณสำเร็จแล้ว',
      register_success_en: 'Register Success',
      enter_mobile: 'กรุณากรอกเบอร์โทรศัพท์ของท่าน',
      enter_password: 'กรุณากรอกรหัสผ่านของท่าน',
      otp_sent: 'รหัส OTP จะส่งไปที่เบอร์มือถือของท่าน',
      mobile_number: 'เบอร์',
      enter_otp: 'กรอกรหัส OTP จากเบอร์มือถือของท่าน',
      verify_otp_btn: 'ยืนยัน OTP',
      resend_otp: 'รับรหัส OTP ใหม่อีกครั้ง',
      confirm_password: 'ยืนยันรหัสผ่าน',
      next: 'ต่อไป',
      back: 'ย้อนกลับ',
      select_bank: 'กรุณาเลือกธนาคารของท่าน',
      select_bank_option: 'เลือกธนาคาร',
      account_number: 'เลขที่บัญชี',
      first_name: 'ชื่อ',
      last_name: 'นามสกุล',
      register: 'สมัครสมาชิก',
      thank_you_message: 'ขอบคุณสำหรับการสมัคร คุณสามารถใช้ชื่อเข้าระบบ และ รหัสผ่าน ด้่านล่างที่ตั้งไว้เพื่อเข้าสู่ระบบ',
      username: 'ชื่อเข้าระบบ',
      password_label: 'รหัสผ่าน',
      go_to_login: 'เข้าสู่ระบบ',
      or: 'หรือ',
      already_have_account: 'มีบัญชีอยู่แล้ว',
      login: 'เข้าสู่ระบบ',
      contact_admin: 'ติดต่อแอดมิน',
      contact_admin_text: 'อย่าลืม ! แอดไลน์ฝ่ายบริการลูกค้าเพื่อรับสิทธิพิเศษ และ แจ้งปัญหาจากการใช้งาน',
      important_notice: '📢 ประกาศสำคัญ',
      important_notice_detail: `ทางเว็บไม่มีนโยบายสนับสนุนให้สมาชิกทำ Turnover เดิมพันสวนกันในบิลเดียวกัน หรือเกมส์เดียวกัน
เพื่อหวังผลรับค่าคอมมิสชั่น หรือเงินปันผล ทั้งในหมวด Sport , Casino และเกมส์เดิมพันทุกประเภท

เว็บมีสิทธิ์ที่จะทำการยกเลิกรายการแทงที่ทุจริตในการเล่นทุกกรณี และจะทำการปิด USER ที่ทุจริตนั้นทันทีโดยไม่ต้องแจ้งให้ทราบล่วงหน้า`,
      acknowledge: 'รับทราบ',
      // Error messages
      please_enter_otp: 'โปรดระบุ OTP ที่ได้รับ!!!',
      otp_incorrect: 'OTP ไม่ถูกต้องโปรดตรวจสอบ OTP ใหม่!!!<br>หากไม่ได้รับโปรดติดต่อแอดมิน',
      otp_not_found: 'OTP ไม่มีในระบบโปรดติดต่อแอดมิน @FunBeyond!!!',
      contact_admin_error: 'โปรดติดต่อแอดมิน @funbeyond',
      message: 'ข้อความ!',
      mobile_password_error: 'เบอร์โทรศัพท์ / รหัสผ่าน ไม่ถูกต้องค่ะ!!!',
      name_exists_error: 'ขื่อนามสกุลเป็นสมาชิกอยู่แล้วค่ะ หากมีปัญหาโปรดติดต่อ @funbeyond',
      please_select_bank: 'กรุณาเลือกธนาคารค่ะ!!!',
      please_enter_account_number: 'กรุณากรอกหมายเลขบัญชีค่ะ!!!',
      please_enter_first_name: 'กรุณากรอกชื่อค่ะ!!!',
      please_enter_last_name: 'กรุณากรอกนามสกุลค่ะ!!!',
      invalid_name_error: 'ชื่อ-นามสกุลไม่ถูกต้อง กรุณากรอกชื่อจริง',
      registration_problem: 'โปรดติดต่อแอดมินที่ @funbeyond เพื่อแจ้งปัญหาในการสมัคร',
      password_length_error: 'กรุณากรอกรหัสผ่านอย่างน้อย 6 ตัวอักษรค่ะ!!!',
      password_mismatch: 'รหัสผ่านไม่ตรงกันค่ะ!!!',
      please_enter_mobile: 'กรุณากรอกเบอร์โทรศัพท์ค่ะ!!!',
      mobile_length_error: 'เบอร์โทร จำนวนตัวอักษรต้อง 10 ตัวเท่านั้นค่ะ!!!',
      please_verify_identity: 'โปรดยืนยันตัวตน',
      mobile_exists_error: 'หมายเลขโทรศัพท์นี้เป็นสมาชิกอยู่แล้วค่ะ หากมีปัญหาโปรดติดต่อ @funbeyond',
    },
    home_page: {
      firstpage: 'หน้าแรก',
      contactus: 'ติดต่อเรา',
      firsttitle: 'ยินดีต้อนรับสู่ Funbeyond โลกแห่งการเดิมพันที่ดีที่สุด',
      checkin_error: 'ยอดฝากรวมต่อวันครบ 100 Check-In ฟรีจ้า..!!!',
      checkin_success: 'ท่าน Check-in เรียบร้อยแล้วค่ะ',
      checkin_error2: 'ท่าน Check-in วันนี้แล้วนะคะรอพรุ่งนี้นะคะ!!!',
      account: 'ข้อมูลบัญชี',
      logout: 'ออกจากระบบ',
      change_password: 'เปลี่ยนรหัสผ่าน',
      contact: `<label class="-text-message ">พบปัญหา</label>
                                    <a href="https://lin.ee/L8YOLQ7" class="-link-message " target="_blank" rel="noopener">
                                        <u>ติดต่อฝ่ายบริการลูกค้า</u>
                                    </a>`,
      password: 'รหัสผ่านปัจจุบัน',
      new_password: 'รหัสผ่านใหม่',
      new_password2: 'ยืนยันรหัสผ่านใหม่',
      confirm: 'ยืนยัน',
      line_login: 'เข้าสู่ระบบด้วยไลน์',
      facebook_login: 'เข้าสู่ระบบด้วย Facebook',
      google_login: 'เข้าสู่ระบบด้วย Google',
      want_withdraw: 'แจ้งถอน',
      turndone: `คุณทำเทิร์นครบแล้ว! จะถอนได้ {canwithdraw} บาท<br> กดปุ่มยืนยันการถอนได้เลยค่ะ`,
      turnfail: `คุณต้องทำยอด {turncredit} ค่ะ`,
      slip_success: 'แจ้งสลิปเรียบร้อย',
      slip_sorry: 'ทีมงานขออภัยในความล่าช้าและจะรีบดำเนินการให้โดยเร็วที่สุด',
      logout_confirm: 'ยืนยันออกจากระบบ',
      withdraw_confirm: 'ทำรายการถอน',
      withdraw_sorry: 'ขออภัยท่านทำรายการถอนครบ 3 ครั้ง ทำรายการได้อีกครั้งหลังเที่ยงคืนนะคะ',
      withdraw_max: 'ไม่สามารถดำเนินการถอนได้ ท่านสามารถทำการถอนได้สูงสุด 450,000 บาท/วัน รบกวนทำการแจ้งถอนใหม่นะคะ',
      withdraw_success: 'เรียบร้อยแล้วกรุณารอเงินเข้าบัญชี',
      withdraw_truewallet: 'การถอน Truewallet จะต้องมียอดฝากขั้นต่ำ 100 บาท กดถอนได้ทันที',
      withdraw_truewallet2: '1. ต้องมีจำนวนมากกว่า 100 <br>2. ลงท้ายด้วย 0 เช่น 110 220 เป็นต้น',
      withdraw_waiting: 'โปรดรออนุมัติรายการถอนก่อนหน้านี้',
      withdraw_credit: 'โปรดตรวจสอบจำนวนเครดิต',
      withdraw_credit2: 'โปรดตรวจสอบจำนวนเครดิต (ถอนขั้นต่ำ 50)',
      password_length: 'โปรดระบุรหัสผ่านมากกว่า 6 หลักค่ะ',
      password_confirm: 'โปรดตรวจสอบรหัสผ่านใหม่อีกครั้งค่ะ',
      password_success: 'เปลี่ยนรหัสผ่านเรียบร้อยแล้วค่ะ',
      password_old: 'โปรดตรวจสอบรหัสผ่านเดิมค่ะ',
    },
    partner_page: {
      share_link_title: 'ลิ้งค์ช่วยแชร์รับ <span style="color:#FAB537">{bonus}%</span> ฟรี ทุก{type}',
      share_more: 'ยิ่งแชร์มากยิ่งได้มาก',
      copy_to_earn: 'แค่ก๊อปปี้ลิ้งค์ไปแชร์ก็ได้เงินแล้ว',
      share_description: 'ท่านสามารถนำลิ้งค์ด้านล่างนี้หรือนำป้ายแบนเนอร์ ไปแชร์ในช่องทางต่างๆ ไม่ว่าจะเป็น เว็บไชต์ส่วนตัว, Blog, Facebook หรือ Social Network อื่นๆ หากมีการสมัครสมาชิกโดยคลิกผ่านลิ้งค์ของท่านเข้ามา ลูกค้าที่สมัครเข้ามาก็จะอยู่ภายใต้เครือข่ายของท่านทันที และหากลูกค้าภายใต้เครือข่ายของท่านมีการเดิมพันเข้ามา ทุกยอดการเดิมพัน ท่านจะได้รับส่วนแบ่งในการแนะนำ {bonus}% ทันทีโดยไม่มีเงื่อนไข',
      daily_earn: 'รับได้ทุกๆวัน สะสมไม่มีวันหาย',
      calculation_example: 'ระบบจะทำการคำนวณยอด เช่น แนะนำสมาชิกได้และสมาชิกมี{type}รวมทั้งหมด 200,000 x {bonus}% = {result} บาท/วัน เป็นรายได้แบบถาวร',
      lifetime_commission: 'ยิ่งแนะนำเยอะ ยิ่งได้เยอะ โยกเงินเข้ากระเป๋าหลักได้ทันที เพียงแค่ชวนมาอยู่ภายใต้ท่านท่านกินค่าคอมมิชชั่นฟรีไปตลอดชีวิต',
      monthly_potential: 'สามารถทำรายได้เดือน 100,000 บาทง่ายๆเลยทีเดียว และรายได้ทุกบาททุกสตางค์ของท่านสามารถตรวจสอบได้ทุกขั้นตอน แจกจริง จ่ายจริง ที่นี่ที่เดียวที่ให้คุณมากกว่าใคร ก๊อปปี้ลิ้งค์นำไปแชร์ได้เลย',
      hero_description: 'แชร์ลิงก์รับรายได้ไม่จำกัด',
      promotion_label: 'โปรโมชั่น',
      alert_title: 'เงื่อนไข',
      alert_credit_limit: 'ต้องมีเครดิตต่ำกว่า 10 บาท ถึงรับได้ค่ะ',
      level1_title: 'แนะนำเพื่อน',
      level2_title: 'เพื่อนแนะนำเพื่อน'
    },
    cashback_page: {
      title: 'คืนยอดเล่น',
      title2: 'ยอดเล่น',
      description: `<p style="text-align: center;padding:30px;font-size: 16px;font-family: Kanit;color:#000;">
                <b class="tt_l tt_full fr_tx1" style="font-size:20px;">คืนยอดรับได้<font color="#FAB537">ทุกวันเวลา 09.00 น.</font> เล่นเสียคืนให้ <font color="#FAB537">5% ว้าวๆ...</font></b>
            </p>
            <p style="text-align: center;padding:0px;font-size: 14px;font-family: Kanit;color:#000;">
                <b class="tt_l tt_full fr_tx1">** ถอนได้ทันทีหรือเล่นต่อก็ได้ไม่มีเงื่อนไข **</b>
            </p>`,
      hero_description: 'รับเงินคืนจากยอดเล่นทุกวัน!',
      info_title: 'เงื่อนไขการคืนยอด'
    },
    history_page: {
      title: 'ประวัติการธุรกรรม',
      title2: 'วัน/เวลา',
      title3: 'ประเภท',
      title4: 'จำนวน',
      title5: 'สถานะ',
      no_data: 'ยังไม่มีรายการ',
      hero_description: 'รายการฝาก-ถอน และโบนัสทั้งหมด',
      summary_label: 'รายการ',
      empty_subtext: 'เมื่อคุณทำธุรกรรมแล้ว ประวัติจะแสดงที่นี่',
      status_success: 'สำเร็จ',
      status_cancelled: 'ยกเลิก',
      status_pending: 'กำลังดำเนินการ',
      type_deposit: 'ฝาก',
      type_withdraw: 'ถอน',
      type_wheel: 'วงล้อ',
      type_roulette: 'รูเล็ต',
      type_continue: 'ฝากต่อเนื่อง',
      type_referral: 'แนะนำ',
      type_cashback: 'คืนยอด'
    },
    continue_page: {
      title: 'ฝากต่อเนื่อง',
      title2: 'ฝากต่อเนื่อง 7 วัน',
      title3: 'โบนัส',
      title4: 'ฝากต่อเนื่อง รับได้ทุกวันเวลา 7.00 น.',
      rules: {
        member_7_days: 'สมาชิกมียอดฝากติดต่อกัน 7 วัน',
        deposit_1000_bonus: 'ฝากรวม 1,000 บ./วัน รับโบนัส 100 บ.',
        deposit_2000_bonus: 'ฝากรวม 2,000 บ./วัน รับโบนัส 200 บ.',
        deposit_3000_bonus: 'ฝากรวม 3,000 บ./วัน รับโบนัส 300 บ.',
        no_bonus_deposit: 'คิดรวมเฉพาะยอดฝากที่ไม่รับโบนัส',
        casino_games_only: 'สามารถนำไปเล่นได้เฉพาะคาสิโน และเกมส์ ใน IMI เท่านั้น',
        no_feature_buy: 'เล่นเกมส์ สล็อตห้ามซื้อฟิเจอร์ (ฟรีสปิน)',
        no_exceed_bonus: 'เล่นคาสิโน ห้ามวางเดิมพันมากกว่าโบนัสที่ได้รับ',
        withdraw_3x: 'ถอนได้เมื่อทำยอด 3 เท่า ของโบนัส',
        max_withdraw_3x: 'สามารถถอนสูงสุด 3 เท่า ของโบนัส',
        bonus_credit_only: 'โบนัสเป็นเครดิตช่วยเล่นไม่สามารถถอนเป็นเงินได้ เมื่อแจ้งถอนโบนัสจะถูกดึงกลับ',
        credit_below_10: 'การรับโบนัสต้องมีเครดิตคงเหลือต่ำกว่า 10 บาท',
        auto_claim_time: 'สามารถกดรับอัตโนมัติ ได้ทางหน้าเว็บทุกวันตั้งแต่เวลา 07:00-23:59 น.',
        violation_warning: 'ตรวจสอบพบการทำผิดกฎ หรือมีการฝากเล่นเพื่อหวังเพียงโบนัส จะถูกดึงเครดิตกลับทั้งหมด และถือเป็นที่สิ้นสุดโปร'
      },
      hero_description: 'ฝากต่อเนื่อง รับโบนัสทุกวัน',
      streak_title: 'สถานะฝากต่อเนื่อง 7 วัน',
      day_label: 'วันที่',
      day_suffix: '/7 วัน',
      status_complete: 'ครบ 7 วันแล้ว! รอรับโบนัส',
      status_active: 'กำลังฝากต่อเนื่อง',
      status_inactive: 'เริ่มฝากเงินเพื่อรับโบนัส',
      rules_title: 'เงื่อนไขโปรโมชั่น',
      alert_wait_withdraw: 'โปรดรอรายการถอนเสร็จเป็นที่เรียบร้อย จึงจะเริ่มทำรายการธุรกรรมอื่นๆต่อไปนะคะ'
    },
    boxs_page:{
      title:'หีบมหาสมบัติ',
      title2:'**เงื่อนไขยอดเสียครบ 250 บาทต่อวัน ได้รับสิทธิ์ทันที**',
      message:'💎 ลูกค้าเปิดหีบสมบัติไปแล้วนะคะวันนี้ รอวันพรุ่งนี้นะคะ 😘',
      message2:'ยอดเสียเมื่อวานขาดอีก {less}(250) ค่ะ!😘😘',
      entrance: 'ทางเข้าเล่น',
      contact: 'ติดต่อ',
      logout_confirm: 'ต้องการล็อกเอาท์จากระบบ',
      success_message: '📦 ปังปุรีเย่!! คุณได้รับ {item} {type} 😘😘',
      empty_message: '📦 งือ ๆ เสียใจด้วยไว้มาลุ้นกันใหม่นะคะ',
    },
    spin_page:{
      title:'วงล้อรับเครดิตฟรี',
      title2:'**เงื่อนไขฝากครบ 500 บาทต่อวัน ได้รับสิทธิ์ทันที**',
      message:'🎡 ลูกค้าหมุนวงล้อของเราไปแล้วนะคะวันนี้ รอวันพรุ่งนี้นะคะ 😘',
      message2:'เติมเงินอีก {less}(500) ได้เล่นเลยค่ะ!😘😘',
      success:'🎡 ปังปุรีเย่!! คุณได้รับ {winner} 😘',
      credit:'เครดิต',
      point:'คะแนน',
      coin:'เหรียญ',
      formula_hours: 'สูตร {hours} ชั่วโมง',
    },
    roulet_page: {
      title:'รูเล็ตรับเครดิตฟรี',
      title2:'**เงื่อนไขฝากครบ 1000 บาทต่อวัน ได้รับสิทธิ์ทันที**',
      message:'🏟 ลูกค้าหมุนรูเล็ตของเราไปแล้วนะคะวันนี้ รอวันพรุ่งนี้นะคะ 😘',
      message2:'เติมเงินอีก {less}(1000) ได้เล่นเลยค่ะ!😘😘',
      fail:'🏟 TT เศร้าสุดๆ 😘😘',
      success:'🏟 ปังปุรีเย่!! คุณได้รับ {winner} เครดิต😘😘',
      spin_now: 'หมุนได้เลย',
    },
    gashapon_page: {
      title: 'กาชาปอง',
      title2: '**เงื่อนไขยอดเสียครบ 100 บาทต่อวัน ได้รับสิทธิ์ทันที**',
      message: '💎 ลูกค้าหมุนกาชาปองของเราไปแล้วนะคะวันนี้ รอวันพรุ่งนี้นะคะ 😘',
      message2: 'ยอดเสียเมื่อวานขาดอีก {less}(500) ค่ะ!😘😘',
      success: '💎 ปังปุรีเย่!! คุณได้รับ {winner} เหรียญ😘😘',
      success_message: '💎 ปังปุรีเย่!! คุณได้รับ {coins} เหรียญ😘😘',
      already_played: '💎 ลูกค้าหมุนกาชาปองของเราไปแล้วนะคะวันนี้ รอวันพรุ่งนี้นะคะ 😘',
      need_more_deposit: 'เติมเงินอีก {amount}(100) ได้เล่นเลยค่ะ!😘😘',
    },
    gift_page: {
      entrance: 'ทางเข้าเล่น',
      contact: 'ติดต่อ',
      logout_confirm: 'ต้องการล็อกเอาท์จากระบบ',
      success_message: '🎁 ปังปุรีเย่!! คุณได้รับ {qty} {type}',
    },
    footer: {
      home: 'หน้าแรก',
      deposit: 'ฝากเงิน',
      withdraw: 'ถอนเงิน',
      contact_us: 'ติดต่อเรา',
      play: 'เข้าเล่น',
    },
    paoyingchup_page: {
      title: 'เป่ายิ้งฉุบ',
      title2: '**เงื่อนไขยอดเสียครบ 1000 บาทต่อวัน ได้รับสิทธิ์ทันที**',
      message: '✌️ ลูกค้าเล่นเป่ายิ้งฉุบของเราไปแล้วนะคะวันนี้ รอวันพรุ่งนี้นะคะ 😘',
      message2: 'ยอดเสียเมื่อวานขาดอีก {less}(1000) ค่ะ!😘😘',
      fail1: 'คุณเสมอเสียใจด้วยนะจ๊ะ 😢',
      fail2: 'คุณแพ้เสียใจด้วยนะจ๊ะ 😢',
      success: '✌️ ปังปุรีเย่!! คุณได้รับ {item} เหรียญ😘😘',
    },
    huekoy_page: {
      title: 'หัวก้อย',
      title2: '**เงื่อนไขมียอดเสีย 2 วันติดต่อกันและมียอดเสียรวมมากกว่า 300 ขึ้นไปได้รับสิทธิ์ทันที**',
      success: '💎 ปังปุรีเย่!! คุณได้รับ 40 เหรียญ😘😘',
      fail: 'เสียใจด้วยนะจ๊ะ 😢',
      message: '💎 ลูกค้าเล่นหัวก้อยของเราไปแล้วนะคะ รอวันใหม่นะคะ 😘',
      message2: '💎 ลูกค้าไม่ได้มียอดเสียสองวันติดนะคะ 😘',
      message3: '💎 ลูกค้าต้องมียอดเสียสองวันมากกว่า {checkcashback} นะคะ 😘',
      message4: '💎 ยอดเสียขาดอีก {less}(300) ค่ะ!😘😘',
      message5: 'พร้อมเล่นได้เลยค่ะ!😘😘'
    },
    huay_page: {
      title: 'แทงหวยไม่ยั้ง',
      title2: '**เงื่อนไขฝากทุกๆ 200 ได้รับสิทธิ์ทันที เฉพาะวันที่หวยออก**',
      description: '**ทุกๆยอดฝาก 200 บาท รับทันที 1 สิทธิ์แทงเลขท้าย 2 ตัวล่าง รัฐบาล แทงถูก!!! รับฟรี 300 เครดิต หากตรวจพบการโกงหรือทุจริตจะถูกตัดสิทธิ์ทันที**',
      confirm_bet: 'ยืนยันแทงหวย',
      bet_success: 'แทงหวยเรียบร้อยแล้วค่ะ 😘',
      check_bet_rights: 'โปรดตรวจสอบสิทธิ์จำนวนที่แทง',
    },
    rewards_page: {
      title: 'ของรางวัลมีให้แลกมากมาย ที่ Funbeyond',
      description: 'แลกได้เมื่อมีเครดิตค้างต่ำกว่า 5 บ.<br>สามารถนำไปเล่นได้เฉพาะเกม และคาสิโน (ห้ามเล่นพนันกีฬา หวย)<br>ไม่สามารถนำไปเล่นใน UFA<br>เล่นเกมส์ สล็อตห้ามซื้อฟิเจอร์ (ฟรีสปิน)<br>ถอนได้เมื่อทำยอด 3 เท่า ถอนได้สูงสุด 5 เท่า<br>โบนัสไม่สามารถถอนเป็นเงินได้ ถูกดึงกลับเมื่อมีการแจ้งถอน<br>สิ้นสุดเงื่อนไขเมื่อมีเครดิตคงเหลือต่ำกว่า 5 บ.',
      subtitle: 'คาสิโนชั้นนำ รวมแบรนด์ดัง มีทุกค่าย รับง่าย ถอนไว',
      footer_description: 'ศูนย์รวมแบรนด์ที่ดีทีสุดและเกมส์คาสิโนทุกเกมส์ไว้ที่นี่ที่เดียว อาทิ UFA IMI และ Betflix เฉพาะครอบครัว FunBeyond เท่านั้น',
      detail: 'ต้องการใช้เหรียญ {name} เล่นเฉพาะเกม หรือคาสิโน\nทำยอด {turn} เท่า ถอนสูงสุด {maxwithdraw} เท่า\nไม่สามารถถอนโบนัสได้',
      confirm: 'ยืนยัน',
      cancel: 'ยกเลิก',
      warning: 'ไม่สามารถแลกเครดิตได้เนื่องจากมียอดคงเหลือมากกว่า 5 บาท',
      warning2: 'ท่านมีมากกว่า 5 เครดิต ไม่สามารถเล่นได้!!!',
      title2: 'แลกเครดิต',
      locked_message: 'ยังไม่ถึงเกณฑ์',
      your_points: 'แต้มของคุณ'
    },
    play_page: {
      alert_maintenance: 'ปิดปรับปรุงระบบ'
    },
    header: {
      account_info: 'ข้อมูลบัญชี',
      bank_management: 'จัดการบัญชีธนาคาร',
      logout: 'ออกจากระบบ',
      change_password: 'เปลี่ยนรหัสผ่าน',
      add_new_account: 'เพิ่มบัญชีใหม่',
      add_account: 'เพิ่มบัญชี',
      approved_accounts: 'บัญชีที่อนุมัติแล้ว',
      pending_accounts: 'บัญชีรอการอนุมัติ',
      no_bank_account: 'ยังไม่มีบัญชีธนาคาร กรุณาเพิ่มบัญชีใหม่',
      contact_support: 'พบปัญหา',
      contact_customer_service: 'ติดต่อฝ่ายบริการลูกค้า'
    },
    special_privileges_for_members: 'สิทธิพิเศษสำหรับสมาชิก',
    menu_labels: {
      promotion: 'โปรโมชั่น',
      transaction: 'ธุรกรรม',
      partner_link: 'ลิ้งค์รับทรัพย์',
      deposit_continue: 'ฝากต่อเนื่อง',
      cashback: 'คืนยอดเล่น',
      spin_wheel: 'วงล้อ',
      roulette: 'รูเล็ต',
      gashapon: 'กาชาปอง',
      lottery: 'แทงหวย',
      rewards: 'แลกของรางวัล',
      watch_series: 'ดูซีรีย์',
      watch_series_jeen: 'ดูซีรีย์จีน',
      watch_movie: 'ดูหนัง',
      watch_sports: 'ดูกีฬา',
      watch_cartoon: 'ดูการ์ตูน',
      ai_hack_slot: 'AI Hack Slot'
    }
    // images: {
    //   title: require('@/assets/images/language/th/title.png'),
    //   play: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fplay%2FLoading_Thai.png?alt=media&token=1272bdde-4918-4e8b-a95d-168033bf9908',
    //   menu: {
    //     promotion: require('@/assets/images/language/th/07.png'),
    //     history: require('@/assets/images/language/th/05.png'),
    //     withdraw: require('@/assets/images/language/th/04.png'),
    //     play: require('@/assets/images/language/th/13.png'),
    //     deposit: require('@/assets/images/language/th/03.png'),
    //     paoyingchup: require('@/assets/images/language/th/01.png'),
    //     gashapon: require('@/assets/images/language/th/16.png'),
    //     checkin: require('@/assets/images/language/th/02.png'),
    //     spin: require('@/assets/images/language/th/09.png'),
    //     roulet: require('@/assets/images/language/th/10.png'),
    //     boxs: require('@/assets/images/language/th/17.png'),
    //     huekoy: require('@/assets/images/language/th/14.png'),
    //     huay: require('@/assets/images/language/th/15.png'),
    //     continue: require('@/assets/images/language/th/12.png'),
    //     partner: require('@/assets/images/language/th/06.png'),
    //     cashback: require('@/assets/images/language/th/08.png'),
    //     rewards: require('@/assets/images/language/th/11.png'),
    //   },
    //   banners: {
    //     banner1: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F01.png?alt=media',
    //     banner2: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F02.png?alt=media',
    //     banner3: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F03.png?alt=media',
    //     banner4: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F04.png?alt=media',
    //     banner5: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F05.png?alt=media',
    //     banner6: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F06.png?alt=media',
    //     banner7: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F07.png?alt=media',
    //     banner8: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F08.png?alt=media',
    //     banner9: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F09.png?alt=media',
    //     banner10: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F10.png?alt=media',
    //     banner11: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F11.png?alt=media',
    //     banner12: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F12.png?alt=media',
    //     banner13: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F13.png?alt=media',
    //     banner14: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F14.png?alt=media',
    //     banner15: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fth%2F15.png?alt=media',
    //   }
    // }
  },
  en: {
    play: 'Play',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    error: 'Error',
    loading: 'Loading...',
    welcome_message: 'Welcome to funbeyond, the best world of betting',
    system_title: 'The Best Casino System with Multiple Brands to Choose From',
    alt_play_skill: 'Random skill games on funbeyond casino online baccarat',
    alt_lottery: 'Lottery betting funbeyond casino online baccarat',
    alt_gashapon: 'Gashapon Funbeyond casino online baccarat',
    alt_reward: 'Redeem rewards Funbeyond casino online baccarat',
    img_title: 'funbeyond the ultimate collection of top brands no.1',
    withdraw_amount: 'Withdrawal Amount',
    withdraw_min: '- Minimum withdrawal: {min} THB per transaction.',
    withdraw_min_max: '- Minimum withdrawal: {min} THB, Maximum: {max} THB per transaction.',
    withdraw_daily_limit: '- Maximum {max} THB and {qtyperday} times per day.',
    withdraw_bank_close: '{detail}',
    withdraw_bank_close_default: '- Bank system maintenance in progress. Please avoid making withdrawal requests during <br>23:50-00:10.',
    withdraw_to_bank: 'Withdraw to this account',
    withdraw_modal: {
      title: 'Withdrawal Transaction',
      error_title: 'Error!',
      max_daily_count: 'Sorry, you have reached the maximum of {count} withdrawal requests for today. Please try again after midnight.',
      max_daily_amount: 'Unable to process. You can withdraw a maximum of {amount} THB/day. Please submit a new request.',
      check_credit_condition: 'Please check your credit amount and withdrawal conditions',
      truewallet_amount_invalid: 'For TrueMoney Wallet, minimum withdrawal is 100 THB and must end with 0 only (e.g., 110, 150, 200)'
    },
    deposit_account: 'Please use the registered account number for deposits only.',
    deposit_promotion: 'If you want to receive a promotion, please claim it every time before making a deposit.',
    deposit_promotion2: 'Receive Promotion',
    deposit_promotion3: 'Do Not Receive Promotion',
    deposit_slip: 'If the funds are not credited within 5 minutes, upload the slip here!',
    deposit_amount: 'Deposit Amount',
    specify_deposit_amount: 'Specify Deposit Amount',
    deposit_instruction: 'Enter the deposit amount or select from the displayed amounts.',
    confirm_deposit: 'Confirm Deposit',
    deposit_promptpay: 'PromptPay Deposit',
    select_bank: 'Select Bank',
    phone_number: 'Phone Number',
    account_number: 'Account Number',
    add_bank_before_withdraw: 'Please add a bank account in account information before withdrawing',
    select_withdraw_account: 'Select Destination Account:',
    select_account_to_receive: 'Select account to receive money',
    please_select_account: 'Please select an account to receive money',
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirm_logout: 'Confirm logout',
    copy_success: 'Copied successfully',
    withdraw_temporarily_closed: 'Withdrawal temporarily closed',
    withdraw_pending: 'Please wait for the withdrawal to be completed before proceeding with other transactions.',
    no_bonus_description: 'No bonus, withdraw instantly with play amount equal to deposit',
    close: 'Close Window',
    close_announcement: 'Acknowledged',
    skip_announcement: 'Skip for Now',
    contact_service: `<span class="x-text-with-link-component" style="font-size:15px;font-family: 'Kanit', sans-serif;">
                    <label class="-text-message ">Having an issue&nbsp;</label>&nbsp;
                    <a href="https://lin.ee/L8YOLQ7" class="-link-message " target="_blank" rel="noopener">
                      <u>Contact Customer Service</u>
                    </a>
                  </span>`,
    promotion: 'Promotion',
    menu_promotion: 'Promotions',
    get_promotion: 'Get Promotion',
    promotion_terms: 'Terms and conditions apply to this promotion',
    partner: 'Partner',
    cashback: 'Cashback',
    title: 'The Best Casino System, Directly from Renowned Casinos in Singapore',
    description_deposit: 'Deposit, no bonus, withdraw instantly without conditions',
    description_all_brands: 'Use all brands',
    all_brands: 'All the best brands are here',
    description_brands: 'The ultimate collection of the best brands and all casino games in one place, including UFA IMI and Betflix, exclusively for the FunBeyond family',
    withdraw_all: 'Move credit to wallet',
    refresh_credit: 'Refresh all credit',
    qty_credit: 'Qty credit',
    footer_description: 'Leading Casino, featuring top brands, all providers available, easy to claim, fast withdrawals.',
    footer_description2: 'The best brands and casino games are here, including UFA IMI AMB and Betflix, only available to Funbeyond family.',
    promotion_title: 'Promotions at Funbeyond are more plentiful and easier to win.',
    link_partner: 'Wealth Earning Link',
    deposit_title: 'Deposit Amount',
    deposit_title2: 'Loss Amount',
    deposit_title3: 'Share the link through any channel to earn with us.',
    partner_title: 'Referral Income',
    partner_title2: 'Refer Friends',
    partner_title3: 'Friends Referring Friends',
    partner_title4: 'Friend Referral Income',
    partner_title5: 'Friend-of-Friend Referral Income',
    partner_title6: 'Total Income',
    partner_title7: 'Transfer to Main Wallet',
    table_code: 'Code',
    table_date: 'Date',
    table_deposit: 'Deposit',
    table_withdraw: 'Withdraw',
    data_summary_yesterday: '*Yesterday\'s summary data',
    contact_problem: 'Having Issues',
    contact_customer_service: 'Contact Customer Service',
    copy: 'Copy',
    copy_button: 'Copy',
    // Placeholders
    current_password_placeholder: 'Current Password',
    new_password_placeholder: 'New Password',
    confirm_new_password_placeholder: 'Confirm New Password',
    amount_baht_placeholder: 'Amount (Baht)',
    // Status messages
    approved_status: 'Approved',
    pending_approval_status: 'Pending Approval',
    loading_status: 'Loading...',
    processing_status: 'Processing...',
    // Button texts
    contact_admin: 'Contact Admin',
    to_this_account: 'To This Account',
    confirm_amount: 'Confirm Amount',
    close_window: 'Close Window',
    cancel_deposit: 'Cancel Deposit',
    acknowledged: 'Acknowledged',
    skip_for_now: 'Skip for Now',
    // Bank and deposit messages
    select_your_bank: 'Select Your Bank',
    please_select_bank_for_deposit: 'Please select your bank for deposit',
    amount_to_transfer: 'Amount to Transfer',
    please_transfer_within_10_minutes: 'Please transfer within 10 minutes',
    time_remaining: 'Time Remaining',
    deposit_from_this_account_only: '⚠️ Make deposits from this account only ⚠️',
    auto_credit_adjustment_warning: 'Automatic credit adjustment system from correct decimal deposit amount. Please do not round off.',
    // Promotion texts
    select_receive_promotion: 'Select Receive Promotion',
    no_promotion: 'No Promotion',
    receive: 'Receive',
    not_receive: 'Not Receive',
    baht_unit: 'Baht',
    // Menu and dialog texts
    logout_confirmation: 'Do you want to logout?',
    login_with_line: 'Login with LINE',
    use_coupon: 'Use Coupon',
    play_through_app: 'Play through App',
    loading_bank_data: 'Loading bank data...',
    no_deposit_channel: 'No deposit channel available at the moment',
    bank_closed_service: 'Bank service closed at this time',
    service_hours: 'Service Hours',
    truewallet_24hrs: 'Truewallet: 24 hours',
    try_again: 'Try Again',
    // Skip option with bank name
    skip_use_first_account: 'Skip (Use first account)',
    // Alt texts for images
    funbeyond_main_alt: 'Funbeyond Online Casino Baccarat Live Slots Sports and Free Credits',
    rewards_exchange_alt: 'PUG888 Exchange Rewards',
    play_game_alt: 'Play Game',
    // Promotion texts
    bonus_2_percent_deposit: 'Get Extra 2% Every Deposit',
    // Additional UI texts
    use_first_account: 'Use First Account',
    no_deposit_channel_available: 'No deposit channel available at the moment',
    bank_closed_now: 'Bank service is closed at this time',
    details: 'Details',
    // Promotion terms
    terms: 'Terms',
    promotion_terms_title: 'Promotion Terms & Conditions',
    promotion_terms_message: 'If you want to receive promotion, please click to receive promotion every time before transferring money\\n\\n▪️Can receive promotion when credit is less than 5 THB\\n▪️Violating promotion terms will result in bonus and played amount being deducted\\n▪️Abnormal betting detected will suspend user and withdraw all credits',
    acknowledge: 'Acknowledge',
    acknowledged_status: 'Acknowledged',
    thai_lang: 'Thai',
    // PromptPay messages
    promptpay_deposit_title: 'PromptPay Deposit Notification',
    amount_must_exceed_300: 'Amount must be more than 300 THB',
    promptpay_problem: 'PromptPay Deposit Problem',
    please_contact_admin: 'Please contact admin',
    promptpay_success: 'PromptPay deposit successful',
    // Promotion terms info
    promotion_terms_info: 'Important Information for Promotion',
    promotion_term_1: 'Promotion available when credit is less than 10 THB',
    promotion_term_2: 'Violating promotion terms will result in bonus and earned amount being deducted',
    promotion_term_3: 'Abnormal betting detected will suspend user and withdraw all credits',
    deposit_type: {
      deposit: 'Deposit Amount',
      loss: 'Loss Amount'
    },
    login_page: {
      mobile: 'Mobile Number',
      forgot_password: 'Forgot Password?',
      contact_admin: 'Contact Admin',
      password: 'Password',
      login_with: 'Log In',
      login_with_line: 'Log In with LINE',
      login_with_facebook: 'Log In with Facebook',
      login_with_google: 'Log In with Google',
      no_account: 'Don\'t have an account yet?',
      register: 'Register',
      change_password: 'Change Password',
      confirm_mobile_account: 'Please enter your mobile number and account number.',
      account_number: 'Account Number',
      new_password: 'Please enter your new password.',
      new_password2: 'New Password',
      confirm_new_password: 'Confirm New Password',
      confirm: 'Confirm',
      please_check_password: 'Please ensure the password information is correct.',
      text_header: 'Message!',
      change_password_success: 'Password changed successfully.',
      please_fill_data: 'Please fill out all the information!',
      please_contact_admin: 'Please contact admin @funbeyondvip',
      mobile_password_error: 'Mobile number or password is incorrect!',
    },
    register_page: {
      title: 'Register',
      verify_otp: 'Verify OTP',
      register_success: 'Your registration has been successful.',
      register_success_en: 'Register Success',
      enter_mobile: 'Please enter your mobile number',
      enter_password: 'Please enter your password',
      otp_sent: 'OTP code will be sent to your mobile number',
      mobile_number: 'Mobile',
      enter_otp: 'Enter OTP code from your mobile number',
      verify_otp_btn: 'Verify OTP',
      resend_otp: 'Resend OTP code',
      confirm_password: 'Confirm Password',
      next: 'Next',
      back: 'Back',
      select_bank: 'Please select your bank',
      select_bank_option: 'Select Bank',
      account_number: 'Account Number',
      first_name: 'First Name',
      last_name: 'Last Name',
      register: 'Register',
      thank_you_message: 'Thank you for registering. You can use the username and password below to log in to the system.',
      username: 'Username',
      password_label: 'Password',
      go_to_login: 'Log In',
      or: 'or',
      already_have_account: 'Already have an account?',
      login: 'Log In',
      contact_admin: 'Contact Admin',
      contact_admin_text: 'Don\'t forget! Add LINE customer service to receive special privileges and report usage issues',
      important_notice: '📢 Important Notice',
      important_notice_detail: `The website does not support members creating turnover by placing opposite bets in the same bill or same game to gain commission or dividends across Sport, Casino, or any betting category.

The website reserves the right to cancel fraudulent bets in all cases and immediately close any fraudulent USER without prior notice.`,
      acknowledge: 'Acknowledge',
      // Error messages
      please_enter_otp: 'Please enter the OTP you received!',
      otp_incorrect: 'OTP is incorrect, please check the OTP again!<br>If not received, please contact admin',
      otp_not_found: 'OTP not found in system, please contact admin @FunBeyond!',
      contact_admin_error: 'Please contact admin @funbeyond',
      message: 'Message!',
      mobile_password_error: 'Mobile number / password is incorrect!',
      name_exists_error: 'This name is already registered. If you encounter issues, please contact @funbeyond',
      please_select_bank: 'Please select a bank!',
      please_enter_account_number: 'Please enter account number!',
      please_enter_first_name: 'Please enter first name!',
      please_enter_last_name: 'Please enter last name!',
      invalid_name_error: 'First name or last name is invalid. Please enter your real name.',
      registration_problem: 'Please contact admin @funbeyond to report registration issues',
      password_length_error: 'Please enter password with at least 6 characters!',
      password_mismatch: 'Passwords do not match!',
      please_enter_mobile: 'Please enter mobile number!',
      mobile_length_error: 'Mobile number must be exactly 10 digits!',
      please_verify_identity: 'Please verify your identity',
      mobile_exists_error: 'This mobile number is already registered. If you encounter issues, please contact @funbeyond',
    },
    home_page: {
      firstpage: 'Home',
      contactus: 'Contact Us',
      firsttitle: 'Welcome to Funbeyond, the Best World of Betting',
      checkin_error: 'Daily total deposits reached 100. Free Check-In available now!',
      checkin_success: 'You have successfully checked in.',
      checkin_error2: 'You have already checked in today. Please come back tomorrow!',
      account: 'Account Information',
      logout: 'Log Out',
      change_password: 'Change Password',
      contact: `<label class="-text-message ">Having an issue?</label>
                      <a href="https://lin.ee/L8YOLQ7" class="-link-message " target="_blank" rel="noopener">
                        <u>Contact Customer Service</u>
                      </a>`,
      password: 'Current Password',
      new_password: 'New Password',
      new_password2: 'Confirm New Password',
      confirm: 'Confirm',
      line_login: 'Log in with LINE',
      facebook_login: 'Log in with Facebook',
      google_login: 'Log in with Google',
      want_withdraw: 'Withdraw Request',
      turndone: `You have completed the required turnover! You can withdraw {canwithdraw} THB.<br> Please press the confirm button to proceed.`,
      turnfail: `You need to complete a turnover of {turncredit}.`,
      slip_success: 'Slip submission completed.',
      slip_sorry: 'We apologize for the delay and will process your request as soon as possible.',
      logout_confirm: 'Confirm Logout',
      withdraw_confirm: 'Confirm Withdrawal',
      withdraw_sorry: 'Sorry, you have reached the maximum of 3 withdrawal requests for today. Please try again after midnight.',
      withdraw_max: 'Unable to process. You can withdraw a maximum of 450,000 THB/day. Please submit a new request.',
      withdraw_success: 'Completed! Please wait for the money to be transferred to your account.',
      withdraw_truewallet: 'For TrueWallet withdrawals, a minimum deposit of 100 THB is required. Click to withdraw instantly.',
      withdraw_truewallet2: '1. The amount must be greater than 100 <br>2. The last digit must end with 0, such as 110 or 220.',
      withdraw_waiting: 'Please wait for the previous withdrawal request to be approved.',
      withdraw_credit: 'Please check the credit amount.',
      withdraw_credit2: 'Please check the credit amount (minimum withdrawal is 50).',
      password_length: 'Please enter a password with more than 6 characters.',
      password_confirm: 'Please recheck your new password.',
      password_success: 'Password successfully changed.',
      password_old: 'Please check your current password.',
    },
    boxs_page: {
      title: 'Treasure Chest',
      title2: '**Condition: Daily total losses of 250 THB to unlock the chest**',
      message: '💎 You have already opened the treasure chest today. Please come back tomorrow 😘',
      message2: 'Your losses yesterday are short by {less} (250 THB)! 😘😘',
      entrance: 'Play Now',
      contact: 'Contact',
      logout_confirm: 'Do you want to logout from the system?',
      success_message: '📦 Amazing! You received {item} {type} 😘😘',
      empty_message: '📦 Oh no! Sorry, please try again next time',
    },
    spin_page: {
      title: 'Spin the Wheel for Free Credits',
      title2: '**Condition: Deposit 500 THB daily to unlock the spin**',
      message: '🎡 You have already spun the wheel today. Please come back tomorrow 😘',
      message2: 'Top up another {less}(500) to spin the wheel now! 😘😘',
      success: '🎡 Amazing! You have won {winner} 😘',
      credit: 'Credit',
      point: 'Point',
      coin: 'Coin',
      formula_hours: 'Formula {hours} hours',
    },
    roulet_page: {
      title: 'Roulette for Free Credits',
      title2: '**Condition: Deposit 1,000 THB daily to unlock the spin**',
      message: '🏟 You have already spun the roulette today. Please come back tomorrow 😘',
      message2: 'Top up another {less}(1,000) to play now! 😘😘',
      fail: '🏟 TT So sad 😘😘',
      success: '🏟 Amazing! You won {winner} credits 😘😘',
      spin_now: 'Spin Now',
    },
    gashapon_page: {
      title: 'Gashapon',
      title2: '**Condition: Daily total losses of 100 THB to unlock the spin**',
      message: '💎 You have already spun the gashapon today. Please come back tomorrow 😘',
      message2: 'Your losses yesterday are short by {less}(500) THB! 😘😘',
      success: '💎 Amazing! You won {winner} coins 😘😘',
      success_message: '💎 Amazing! You won {coins} coins 😘😘',
      already_played: '💎 You have already spun the gashapon today. Please come back tomorrow 😘',
      need_more_deposit: 'Deposit {amount}(100) more to play! 😘😘',
    },
    gift_page: {
      entrance: 'Play Now',
      contact: 'Contact',
      logout_confirm: 'Do you want to logout from the system?',
      success_message: '🎁 Amazing! You received {qty} {type}',
    },
    footer: {
      home: 'Home',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      contact_us: 'Contact Us',
      play: 'Play',
    },
    paoyingchup_page: {
      title: 'Rock-Paper-Scissors',
      title2: '**Condition: Daily total losses of 1,000 THB to unlock the game**',
      message: '✌️ You have already played Rock-Paper-Scissors today. Please come back tomorrow 😘',
      message2: 'Your losses yesterday are short by {less}(1,000) THB! 😘😘',
      fail1: "It's a tie! Better luck next time 😢",
      fail2: 'You lost! Sorry to hear that 😢',
      success: '✌️ Amazing! You won {item} coins 😘😘',
    },
    huekoy_page: {
      title: 'Heads or Tails',
      title2: '**Condition: Have losses for 2 consecutive days with a total loss of more than 300 to unlock the reward**',
      success: '💎 Amazing! You have won 40 coins 😘😘',
      fail: 'Sorry to hear that 😢',
      message: '💎 You have already played Heads or Tails today. Please come back tomorrow 😘',
      message2: '💎 You have not had losses for two consecutive days 😘',
      message3: '💎 You need to have losses for two days totaling more than {checkcashback} 😘',
      message4: '💎 You are short by {less}(300) in losses 😘😘',
      message5: 'Ready to play now! 😘😘',
    },
    huay_page: {
      title: 'Unlimited Lottery Betting',
      title2: '**Condition: Deposit 200 THB for each ticket, only on lottery draw days**',
      description: '**For every deposit of 200 THB, get 1 chance to bet on the last 2 digits of the Thai Government Lottery. Win and receive 300 credits for free! Any fraud or cheating will result in disqualification.**',
      confirm_bet: 'Confirm Lottery Bet',
      bet_success: 'Your lottery bet has been placed successfully 😘',
      check_bet_rights: 'Please check the number of tickets before placing your bet.',
    },
    rewards_page: {
      title: 'Redeem a Variety of Rewards at Funbeyond',
      description: 'Can be redeemed when having credit balance below 5 THB.<br>Can only be used for games and casino (no sports betting, lottery)<br>Cannot be used in UFA<br>Slot games: no buying features (free spins)<br>Withdraw after 3x turnover, maximum withdrawal 5x<br>Bonus cannot be withdrawn as cash, will be deducted upon withdrawal request<br>Terms end when credit balance is below 5 THB.',
      subtitle: 'Leading Casino with Top Brands and All Providers - Easy Deposit, Fast Withdrawal',
      footer_description: 'The hub of the best brands and all casino games in one place, including AMB, UFA, IMI and Betflix, exclusively for the FunBeyond family.',
      detail: 'Do you want to use {name} coins for games or casino only?\nMake a turnover of {turn} times, withdraw up to {maxwithdraw} times\nBonus cannot be withdrawn',
      confirm: 'Confirm',
      cancel: 'Cancel',
      warning: 'Unable to redeem credits as your balance exceeds 5 THB.',
      warning2: 'You have more than 5 credits and cannot proceed!',
      title2: 'Redeem Credits',
      locked_message: 'Not Eligible',
      your_points: 'Your Points'
    },
    play_page: {
      alert_maintenance: 'System Maintenance'
    },
    header: {
      account_info: 'Account Information',
      bank_management: 'Bank Management',
      logout: 'Logout',
      change_password: 'Change Password',
      add_new_account: 'Add New Account',
      add_account: 'Add Account',
      approved_accounts: 'Approved Accounts',
      pending_accounts: 'Pending Accounts',
      no_bank_account: 'No bank account yet, please add a new account',
      contact_support: 'Need Help',
      contact_customer_service: 'Contact Customer Service'
    },
    special_privileges_for_members: 'Special Privileges for Members',
    menu_labels: {
      promotion: 'Promotion',
      transaction: 'Transaction',
      partner_link: 'Partner Link',
      deposit_continue: 'Deposit Continue',
      cashback: 'Cashback',
      spin_wheel: 'Spin Wheel',
      roulette: 'Roulette',
      gashapon: 'Gashapon',
      lottery: 'Lottery',
      rewards: 'Rewards',
      watch_series: 'Watch Series',
      watch_series_jeen: 'Watch Chinese Series',
      watch_movie: 'Watch Movie',
      watch_sports: 'Watch Sports',
      watch_cartoon: 'Watch Cartoon',
      ai_hack_slot: 'AI Hack Slot'
    },
    partner_page: {
      share_link_title: 'Share links to earn <span style="color:#FAB537">{bonus}%</span> free on every {type}',
      share_more: 'The more you share, the more you earn',
      copy_to_earn: 'Just copy and share the link to start earning',
      share_description: 'You can share this link or banner through various channels such as personal websites, blogs, Facebook, or other social networks. When someone registers through your link, they will be under your network. For every bet they make, you will receive {bonus}% commission instantly without any conditions.',
      daily_earn: 'Earn daily with no expiration',
      calculation_example: 'System calculates: For example, if your referrals have total {type} of 200,000 x {bonus}% = {result} baht/day as permanent income',
      lifetime_commission: 'The more you refer, the more you earn. Transfer to your main wallet instantly. Just invite them under you to earn commission free for life',
      monthly_potential: 'Easily earn 100,000 baht per month. Every baht of your income can be verified at every step. Real rewards, real payments. Only here gives you more than anyone else. Copy the link and start sharing now',
      hero_description: 'Share Link, Earn Unlimited Income',
      promotion_label: 'Promotion',
      alert_title: 'Conditions',
      alert_credit_limit: 'You must have less than 10 baht credit to receive',
      level1_title: 'Refer Friends',
      level2_title: 'Friend Refers Friend'
    },
    cashback_page: {
      title: 'Cashback',
      title2: 'Turnover',
      description: `<p style="text-align: center;padding:30px;font-size: 16px;font-family: Kanit;color:#000;">
                    <b class="tt_l tt_full fr_tx1" style="font-size:20px;">Get cashback <font color="#FAB537">every day at 09:00 AM.</font> Receive <font color="#FAB537">5% cashback</font> on losses. Wow!</b>
                </p>
                <p style="text-align: center;padding:0px;font-size: 14px;font-family: Kanit;color:#000;">
                    <b class="tt_l tt_full fr_tx1">** Withdraw instantly or continue playing without conditions **</b>
                </p>`,
      hero_description: 'Get Daily Cashback from Your Play Amount!',
      info_title: 'Cashback Terms'
    },
    history_page: {
      title: 'Cashback History',
      title2: 'Date/Time',
      title3: 'Type',
      title4: 'Amount',
      title5: 'Status',
      no_data: 'No data',
      hero_description: 'All Deposit-Withdraw and Bonus Transactions',
      summary_label: 'Transactions',
      empty_subtext: 'When you make transactions, history will appear here',
      status_success: 'Success',
      status_cancelled: 'Cancelled',
      status_pending: 'Pending',
      type_deposit: 'Deposit',
      type_withdraw: 'Withdraw',
      type_wheel: 'Wheel',
      type_roulette: 'Roulette',
      type_continue: 'Continuous Deposit',
      type_referral: 'Referral',
      type_cashback: 'Cashback'
    },
    continue_page: {
      title: 'Continuous Deposit',
      title2: 'Deposit Continuously for 7 Days',
      title3: 'Bonus',
      title4: 'Deposit continuously and claim every day at 7:00 AM',
      rules: {
        member_7_days: 'Members with continuous deposits for 7 days',
        deposit_1000_bonus: 'Total deposit 1,000 THB/day, get 100 THB bonus',
        deposit_2000_bonus: 'Total deposit 2,000 THB/day, get 200 THB bonus',
        deposit_3000_bonus: 'Total deposit 3,000 THB/day, get 300 THB bonus',
        no_bonus_deposit: 'Calculated only for deposits that do not receive bonuses',
        casino_games_only: 'Can only be played in Casino and Games in IMI',
        no_feature_buy: 'Playing slot games, no feature buy (free spins)',
        no_exceed_bonus: 'Playing casino, no betting more than the bonus received',
        withdraw_3x: 'Can withdraw when turnover is 3 times the bonus',
        max_withdraw_3x: 'Maximum withdrawal is 3 times the bonus',
        bonus_credit_only: 'Bonus is playing credit, cannot be withdrawn as cash. When requesting withdrawal, bonus will be deducted',
        credit_below_10: 'To receive bonus, remaining credit must be less than 10 THB',
        auto_claim_time: 'Can claim automatically on the website every day from 07:00-23:59',
        violation_warning: 'If found violating rules or depositing just for bonus, all credit will be pulled back and considered final'
      },
      hero_description: 'Deposit Consecutively, Get Daily Bonus',
      streak_title: '7-Day Consecutive Deposit Status',
      day_label: 'Day',
      day_suffix: '/7 Days',
      status_complete: '7 Days Completed! Wait for Bonus',
      status_active: 'Depositing Consecutively',
      status_inactive: 'Start Depositing to Receive Bonus',
      rules_title: 'Promotion Terms',
      alert_wait_withdraw: 'Please wait for the withdrawal to be completed before proceeding with other transactions.'
    },
    // images: {
    //   title: require('@/assets/images/language/en/title.png'),
    //   play: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fplay%2FLoading_Eng.png?alt=media&token=1573da13-8c32-4eee-ab26-32e717bf487e',
    //   menu: {
    //     promotion: require('@/assets/images/language/en/07.png'),
    //     history: require('@/assets/images/language/en/05.png'),
    //     withdraw: require('@/assets/images/language/en/04.png'),
    //     play: require('@/assets/images/language/en/13.png'),
    //     deposit: require('@/assets/images/language/en/03.png'),
    //     paoyingchup: require('@/assets/images/language/en/01.png'),
    //     gashapon: require('@/assets/images/language/en/16.png'),
    //     checkin: require('@/assets/images/language/en/02.png'),
    //     spin: require('@/assets/images/language/en/09.png'),
    //     roulet: require('@/assets/images/language/en/10.png'),
    //     boxs: require('@/assets/images/language/en/17.png'),
    //     huekoy: require('@/assets/images/language/en/14.png'),
    //     huay: require('@/assets/images/language/en/15.png'),
    //     continue: require('@/assets/images/language/en/12.png'),
    //     partner: require('@/assets/images/language/en/06.png'),
    //     cashback: require('@/assets/images/language/en/08.png'),
    //     rewards: require('@/assets/images/language/en/11.png'),
    //   },
    //   banners: {
    //     banner1: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F01.png?alt=media',
    //     banner2: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F02.png?alt=media',
    //     banner3: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F03.png?alt=media',
    //     banner4: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F04.png?alt=media',
    //     banner5: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F05.png?alt=media',
    //     banner6: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F06.png?alt=media',
    //     banner7: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F07.png?alt=media',
    //     banner8: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F08.png?alt=media',
    //     banner9: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F09.png?alt=media',
    //     banner10: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F10.png?alt=media',
    //     banner11: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F11.png?alt=media',
    //     banner12: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F12.png?alt=media',
    //     banner13: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F13.png?alt=media',
    //     banner14: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F14.png?alt=media',
    //     banner15: 'https://firebasestorage.googleapis.com/v0/b/shiba-88.appspot.com/o/images%2Fbanners%2Fwinter%2Fen%2F15.png?alt=media',
    //   }
    // }
  },
  my: {
    play: 'ကစားရန်',
    deposit: 'ငွေထည့်ရန်',
    withdraw: 'ငွေထုတ်ရန်',
    error: 'အမှား',
    loading: 'ဖွင့်နေသည်...',
    welcome_message: 'အကောင်းဆုံး လောင်းကစားကမ္ဘာသို့ ကြိုဆိုပါသည်',
    system_title: 'အမျိုးမျိုးသော ဘရန်များကို ရွေးချယ်နိုင်သော အကောင်းဆုံး ကစားခန်းစနစ်',
    alt_play_skill: 'ကျွမ်းကျင်မှုအပေါ် အခြေခံသော ကစားနည်းများ',
    alt_lottery: 'ထီထိုးခြင်း',
    alt_gashapon: 'ဂါရှာပွန်',
    alt_reward: 'ဆုကြေးများ လဲယူခြင်း',
    img_title: 'အကောင်းဆုံး ဘရန်များ၏ စုစည်းမှု',
    withdraw_amount: 'ထုတ်ယူမည့် ပမာဏ',
    withdraw_min: '- အနည်းဆုံး ထုတ်ယူမှု: {min} ကျပ် / ငွေကြေးတစ်ခုချင်းစီ။',
    withdraw_min_max: '- အနည်းဆုံး ထုတ်ယူမှု: {min} ကျပ်၊ အများဆုံး: {max} ကျပ် / ငွေကြေးတစ်ခုချင်းစီ။',
    withdraw_daily_limit: '- အများဆုံး {max} ကျပ် နှင့် တစ်နေ့လျှင် {qtyperday} ကြိမ်။',
    withdraw_bank_close: '{detail}',
    withdraw_bank_close_default: '- ဘဏ်စနစ် ပြင်ဆင်မှုများ လုပ်ဆောင်နေသည်။ ကျေးဇူးပြု၍ <br>23:50-00:10 အတွင်း ငွေထုတ်ယူမှု တောင်းဆိုချက်များ မပြုလုပ်ပါနှင့်။',
    withdraw_to_bank: 'ဤအကောင့်သို့ ငွေထုတ်ယူရန်',
    withdraw_modal: {
      title: 'ငွေထုတ်ယူမှု လုပ်ဆောင်ချက်',
      error_title: 'အမှား!',
      max_daily_count: 'ဆိုးပါတယ်၊ ယနေ့အတွက် ငွေထုတ်ယူမှု တောင်းဆိုချက် {count} ကြိမ် အများဆုံးရောက်ရှိပါပြီ။ ညသန်းခေါင်ပြီးနောက် ပြန်လည်ကြိုးစားပါ။',
      max_daily_amount: 'ပြုလုပ်မရပါ။ နေ့စဉ် အများဆုံး {amount} ကျပ် ထုတ်ယူနိုင်ပါသည်။ ကျေးဇူးပြု၍ တောင်းဆိုချက်အသစ် တင်ပါ။',
      check_credit_condition: 'ကျေးဇူးပြု၍ ခရက်ဒစ်ပမာဏနှင့် ငွေထုတ်ယူမှု စည်းမျဉ်းများကို စစ်ဆေးပါ',
      truewallet_amount_invalid: 'TrueMoney Wallet အတွက် ငွေထုတ်ယူမှု အနည်းဆုံး 100 ကျပ် ဖြစ်ပြီး 0 ဖြင့်သာ ဆုံးရမည် (ဥပမာ 110, 150, 200)'
    },
    deposit_account: 'ကျေးဇူးပြု၍ ငွေထည့်ရန်အတွက်သာ မှတ်ပုံတင်ထားသော အကောင့်နံပါတ်ကို အသုံးပြုပါ။',
    deposit_promotion: 'ပရိုမိုရှင်း ရရှိလိုပါက ငွေထည့်မည့်အခါတိုင်း ကြိုတင်ရယူပါ။',
    deposit_promotion2: 'ပရိုမိုရှင်း ရယူရန်',
    deposit_promotion3: 'ပရိုမိုရှင်း မရယူရန်',
    deposit_slip: 'ငွေများ 5 မိနစ်အတွင်း မရောက်ရှိပါက ဤနေရာတွင် စလစ်ကို တင်ပါ!',
    deposit_amount: 'ငွေထည့်မည့် ပမာဏ',
    specify_deposit_amount: 'ငွေထည့်မည့် ပမာဏကို ရွေးပါ',
    deposit_instruction: 'ငွေထည့်မည့် ပမာဏကို ထည့်သွင်းပါ သို့မဟုတ် ပြသထားသော ပမာဏများထဲမှ ရွေးချယ်ပါ။',
    confirm_deposit: 'ငွေထည့်မှုကို အတည်ပြုရန်',
    deposit_promptpay: 'ငွေထည့်ရန်',
    confirm: 'အတည်ပြုရန်',
    cancel: 'ပယ်ဖျက်ရန်',
    select_bank: 'ဘဏ်ကို ရွေးချယ်ပါ',
    phone_number: 'ဖုန်းနံပါတ်',
    account_number: 'အကောင့်နံပါတ်',
    login_page: {
      mobile: 'ဖုန်းနံပါတ်',
      forgot_password: 'စကားဝှက် မေ့နေပါသလား?',
      contact_admin: 'အက်ဒမင် ဆက်သွယ်ရန်',
      password: 'စကားဝှက်',
      login_with: 'ဝင်ရန်',
      login_with_line: 'LINE ဖြင့် ဝင်ရန်',
      login_with_facebook: 'Facebook ဖြင့် ဝင်ရန်',
      login_with_google: 'Google ဖြင့် ဝင်ရန်',
      no_account: 'အကောင့် မရှိသေးပါသလား?',
      register: 'စာရင်းသွင်းရန်',
      change_password: 'စကားဝှက် ပြောင်းရန်',
      confirm_mobile_account: 'ဖုန်းနံပါတ်နှင့် အကောင့်နံပါတ် ထည့်ပါ',
      account_number: 'အကောင့်နံပါတ်',
      new_password: 'စကားဝှက်အသစ် ထည့်ပါ',
      new_password2: 'စကားဝှက်အသစ်',
      confirm_new_password: 'စကားဝှက်အသစ် အတည်ပြုရန်',
      confirm: 'အတည်ပြုရန်',
      please_check_password: 'စကားဝှက်အချက်အလက် မှန်ကန်မှုကို စစ်ဆေးပါ',
      text_header: 'စာတို!',
      change_password_success: 'စကားဝှက် ပြောင်းလဲပြီးပါပြီ',
      please_fill_data: 'အချက်အလက်အားလုံး ဖြည့်ပါ!',
      please_contact_admin: 'အက်ဒမင် @funbeyondvip ကို ဆက်သွယ်ပါ',
      mobile_password_error: 'ဖုန်းနံပါတ် သို့မဟုတ် စကားဝှက် မမှန်ပါ!',
    },
    register_page: {
      title: 'စာရင်းသွင်းရန်',
      verify_otp: 'OTP အတည်ပြုရန်',
      register_success: 'သင်၏ စာရင်းသွင်းမှု အောင်မြင်ပါပြီ',
      register_success_en: 'Register Success',
      contact_admin_text: 'မမေ့ပါနှင့်! အထူးအခွင့်အရေးများရယူရန်နှင့် အသုံးပြုမှု ပြဿနာများแจ้งရန် LINE ဖောက်သည်ဝန်ဆောင်မှုကို ထည့်ပါ',
      enter_mobile: 'သင့်ဖုန်းနံပါတ် ထည့်ပါ',
      enter_password: 'သင့်စကားဝှက် ထည့်ပါ',
      otp_sent: 'OTP ကုဒ်ကို သင့်ဖုန်းနံပါတ်သို့ ပေးပို့ပါမည်',
      mobile_number: 'ဖုန်းနံပါတ်',
      enter_otp: 'သင့်ဖုန်းမှ ရရှိသော OTP ကုဒ် ထည့်ပါ',
      verify_otp_btn: 'OTP အတည်ပြုရန်',
      resend_otp: 'OTP ကုဒ် ပြန်ပို့ရန်',
      confirm_password: 'စကားဝှက် အတည်ပြုရန်',
      next: 'ရှေ့သို့',
      back: 'နောက်သို့',
      select_bank: 'သင့်ဘဏ်ကို ရွေးပါ',
      select_bank_option: 'ဘဏ်ရွေးပါ',
      account_number: 'အကောင့်နံပါတ်',
      first_name: 'အမည်',
      last_name: 'မျိုးရိုးအမည်',
      register: 'စာရင်းသွင်းရန်',
      thank_you_message: 'စာရင်းသွင်းပေးသည့်အတွက် ကျေးဇူးတင်ပါသည်။ အောက်ပါ အသုံးပြုသူအမည်နှင့် စကားဝှက်ဖြင့် စနစ်သို့ ဝင်နိုင်ပါသည်။',
      username: 'အသုံးပြုသူအမည်',
      password_label: 'စကားဝှက်',
      go_to_login: 'ဝင်ရန်',
      or: 'သို့မဟုတ်',
      already_have_account: 'အကောင့် ရှိပြီးသားလား?',
      login: 'ဝင်ရန်',
      contact_admin: 'အက်ဒမင် ဆက်သွယ်ရန်',
      important_notice: '📢 အရေးကြီးကြေညာချက်',
      important_notice_detail: `ဝဘ်ဆိုက်သည် Sport, Casino နှင့် လောင်းကစားအမျိုးအစားအားလုံးတွင် ကော်မရှင် သို့မဟုတ် အကျိုးခံစားခွင့် ရယူရန် တူညီသောဘေလ် သို့မဟုတ် တူညီသောဂိမ်းအတွင်း ဆန့်ကျင်လောင်းကစားပြုလုပ်၍ Turnover တိုးမြှင့်ခြင်းကို မထောက်ခံပါ။

မမှန်မကန် လောင်းကစားတွေ့ရှိပါက ဝဘ်ဆိုက်သည် လောင်းကစားမှုကို ပယ်ဖျက်နိုင်ပြီး USER ကို ကြိုတင်အသိပေးခြင်းမရှိဘဲ ချက်ချင်း ပိတ်နိုင်ပါသည်။`,
      acknowledge: 'နားလည်ပါပြီ',
      please_enter_otp: 'ရရှိထားသော OTP ကို ထည့်ပါ!',
      otp_incorrect: 'OTP မမှန်ပါ။ ပြန်စစ်ဆေးပါ!<br>မရရှိပါက အက်ဒမင်ကို ဆက်သွယ်ပါ',
      otp_not_found: 'စနစ်တွင် OTP မတွေ့ပါ။ အက်ဒမင် @funbeyond ကို ဆက်သွယ်ပါ!',
      contact_admin_error: 'အက်ဒမင် @funbeyond ကို ဆက်သွယ်ပါ',
      message: 'စာတို!',
      mobile_password_error: 'ဖုန်းနံပါတ် / စကားဝှက် မမှန်ပါ!',
      name_exists_error: 'ဤအမည်သည် စာရင်းသွင်းပြီးသား ဖြစ်ပါသည်။ ပြဿနာရှိပါက @funbeyond ကို ဆက်သွယ်ပါ',
      please_select_bank: 'ဘဏ်ရွေးပါ!',
      please_enter_account_number: 'အကောင့်နံပါတ် ထည့်ပါ!',
      please_enter_first_name: 'အမည် ထည့်ပါ!',
      please_enter_last_name: 'မျိုးရိုးအမည် ထည့်ပါ!',
      invalid_name_error: 'အမည် သို့မဟုတ် မျိုးရိုးအမည် မမှန်ပါ။ အမည်အမှန် ထည့်ပါ',
      registration_problem: 'စာရင်းသွင်းမှု ပြဿနာအတွက် အက်ဒမင် @funbeyond ကို ဆက်သွယ်ပါ',
      password_length_error: 'အနည်းဆုံး စာလုံး 6 လုံးပါသော စကားဝှက် ထည့်ပါ!',
      password_mismatch: 'စကားဝှက်များ မတူပါ!',
      please_enter_mobile: 'ဖုန်းနံပါတ် ထည့်ပါ!',
      mobile_length_error: 'ဖုန်းနံပါတ်သည် 10 လုံး ဖြစ်ရမည်!',
      please_verify_identity: 'သင့်ကိုယ်ရေးကို အတည်ပြုပါ',
      mobile_exists_error: 'ဤဖုန်းနံပါတ်သည် စာရင်းသွင်းပြီးသား ဖြစ်ပါသည်။ ပြဿနာရှိပါက @funbeyond ကို ဆက်သွယ်ပါ',
    },
    partner: 'ပါတနာ',
    cashback: 'ငွေပြန်ရရှိမှု',
    continue_page: {
      title: 'ဆက်တိုက် ငွေထည့်ခြင်း',
      title2: '7 ရက်ဆက်တိုက် ငွေထည့်ခြင်း',
      title3: 'ဘောနပ်စ်',
      title4: 'ဆက်တိုက် ငွေထည့်ပြီး နေ့စဉ် နံနက် 7:00 နာရီတွင် ရယူပါ',
      rules: {
        member_7_days: 'အဖွဲ့ဝင်များ 7 ရက်ဆက်တိုက် ငွေထည့်မှုရှိရမည်',
        deposit_1000_bonus: 'စုစုပေါင်း ငွေထည့်မှု 1,000 ကျပ်/နေ့၊ ဘောနပ်စ် 100 ကျပ် ရယူရန်',
        deposit_2000_bonus: 'စုစုပေါင်း ငွေထည့်မှု 2,000 ကျပ်/နေ့၊ ဘောနပ်စ် 200 ကျပ် ရယူရန်',
        deposit_3000_bonus: 'စုစုပေါင်း ငွေထည့်မှု 3,000 ကျပ်/နေ့၊ ဘောနပ်စ် 300 ကျပ် ရယူရန်',
        no_bonus_deposit: 'ဘောနပ်စ် မရရှိသော ငွေထည့်မှုများကိုသာ ရေတွက်သည်',
        casino_games_only: 'IMI ရှိ ကစားခန်းနှင့် ဂိမ်းများတွက်သာ ကစားနိုင်သည်',
        no_feature_buy: 'ဂိမ်းကစားခြင်း၊ စလော့များတွင် အင်္ဂါရပ်များ မဝယ်ရ (အခမဲ့စပင်များ)',
        no_exceed_bonus: 'ကစားခန်းကစားခြင်း၊ ရရှိသော ဘောနပ်စ်ထက် ပိုမလောင်းရ',
        withdraw_3x: 'ဘောနပ်စ်၏ 3 ဆ လည်ပတ်မှုပြုလုပ်ပါက ထုတ်ယူနိုင်သည်',
        max_withdraw_3x: 'အများဆုံး ထုတ်ယူမှုသည် ဘောနပ်စ်၏ 3 ဆ ဖြစ်သည်',
        bonus_credit_only: 'ဘောနပ်စ်သည် ကစားရန် ခရက်ဒစ်ဖြစ်ပြီး ငွေအဖြစ် ထုတ်ယူ၍မရပါ။ ထုတ်ယူမှု တောင်းဆိုသောအခါ ဘောနပ်စ်ကို နုတ်ယူပါမည်',
        credit_below_10: 'ဘောနပ်စ် ရယူရန် ကျန်ရှိသော ခရက်ဒစ်သည် 10 ကျပ် အောက်ရှိရမည်',
        auto_claim_time: 'နေ့စဉ် 07:00-23:59 အတွင်း ဝဘ်ဆိုက်တွင် အလိုအလျောက် ရယူနိုင်သည်',
        violation_warning: 'စည်းမျဉ်းချိုးဖောက်မှု သို့မဟုတ် ဘောနပ်စ်အတွက်သာ ငွေထည့်မှုကို တွေ့ရှိပါက ခရက်ဒစ်အားလုံးကို ပြန်နုတ်ယူပြီး အဆုံးသတ်ပါမည်'
      },
      hero_description: 'ဆက်တိုက်ငွေသွင်း၊ နေ့စဉ်ဘောနပ်စ်ရယူ',
      streak_title: 'ရက် ၇ ရက် ဆက်တိုက်ငွေသွင်းမှု အခြေအနေ',
      day_label: 'နေ့',
      day_suffix: '/၇ ရက်',
      status_complete: 'ရက် ၇ ရက် ပြည့်ပြီ! ဘောနပ်စ်ကို စောင့်ပါ',
      status_active: 'ဆက်တိုက်ငွေသွင်းနေသည်',
      status_inactive: 'ဘောနပ်စ်ရရှိရန် ငွေသွင်းရန် စတင်ပါ',
      rules_title: 'ပရိုမိုးရှင်း စည်းကမ်းချက်များ',
      alert_wait_withdraw: 'ငွေထုတ်မှု ပြီးဆုံးသည်အထိ စောင့်ပါ၊ ထို့နောက် အခြား ငွေကြေးလုပ်ဆောင်ချက်များ ဆက်လက်လုပ်ဆောင်နိုင်ပါသည်။'
    },
    footer: {
      home: 'ပင်မစာမျက်နှာ',
      deposit: 'ငွေထည့်ရန်',
      withdraw: 'ငွေထုတ်ရန်',
      contact_us: 'ဆက်သွယ်ရန်',
      play: 'ကစားရန်'
    },
    header: {
      account_info: 'အကောင့် အချက်အလက်',
      bank_management: 'ဘဏ်စီမံခန့်ခွဲမှု',
      logout: 'ထွက်ရန်',
      change_password: 'စကားဝှက် ပြောင်းရန်',
      add_new_account: 'အကောင့်အသစ် ထည့်ရန်',
      add_account: 'အကောင့် ထည့်ရန်',
      approved_accounts: 'အတည်ပြုပြီး အကောင့်များ',
      pending_accounts: 'စောင့်ဆိုင်းနေသော အကောင့်များ',
      no_bank_account: 'ဘဏ်အကောင့် မရှိသေးပါ၊ ကျေးဇူးပြု၍ အကောင့်အသစ် ထည့်ပါ',
      contact_support: 'အကူအညီ လိုအပ်သည်',
      contact_customer_service: 'ဖောက်သည်ဝန်ဆောင်မှု ဆက်သွယ်ရန်'
    },
    menu_labels: {
      promotion: 'ပရိုမိုရှင်း',
      transaction: 'ငွေကြေးလွှဲပြောင်းမှု',
      partner_link: 'ပါတနာ လင့်ခ်',
      deposit_continue: 'ဆက်တိုက် ငွေထည့်ခြင်း',
      cashback: 'ငွေပြန်ရရှိမှု',
      spin_wheel: 'စပင်ဘီး',
      roulette: 'ရူးလက်',
      gashapon: 'ဂါရှာပွန်',
      lottery: 'ထီထိုးခြင်း',
      rewards: 'ဆုကြေးများ',
      watch_series: 'ဇာတ်လမ်းတွဲ ကြည့်ရှုရန်',
      watch_series_jeen: 'တရုတ် ဇာတ်လမ်းတွဲ ကြည့်ရှုရန်',
      watch_movie: 'ရုပ်ရှင် ကြည့်ရှုရန်',
      watch_sports: 'အားကစား ကြည့်ရှုရန်',
      watch_cartoon: 'ကာတွန်း ကြည့်ရှုရန်',
      ai_hack_slot: 'AI Hack Slot'
    },
    // Placeholders
    current_password_placeholder: 'လက်ရှိစကားဝှက်',
    new_password_placeholder: 'စကားဝှက်အသစ်',
    confirm_new_password_placeholder: 'စကားဝှက်အသစ် အတည်ပြုရန်',
    amount_baht_placeholder: 'ပမာဏ (ကျပ်)',
    // Status messages
    approved_status: 'အတည်ပြုပြီး',
    pending_approval_status: 'အတည်ပြုမှု စောင့်ဆိုင်းနေ',
    loading_status: 'ဖွင့်နေသည်...',
    processing_status: 'ပြုလုပ်နေသည်...',
    // Button texts
    contact_admin: 'အက်ဒ်မင်ဆက်သွယ်ရန်',
    to_this_account: 'ဤအကောင့်သို့',
    confirm_amount: 'ပမာဏ အတည်ပြုရန်',
    close_window: 'ဝင်းဒိုး ပိတ်ရန်',
    cancel_deposit: 'ငွေထည့်မှု ပယ်ဖျက်ရန်',
    acknowledged: 'အတည်ပြုပြီး',
    skip_for_now: 'ယခုအတွက် ကျော်သွားရန်',
    // Bank and deposit messages
    select_your_bank: 'သင့်ဘဏ်ကို ရွေးပါ',
    please_select_bank_for_deposit: 'ငွေထည့်ရန်အတွက် သင့်ဘဏ်ကို ရွေးချယ်ပါ',
    amount_to_transfer: 'လွှဲပြောင်းမည့် ပမာဏ',
    please_transfer_within_10_minutes: '10 မိနစ်အတွင်း လွှဲပြောင်းပါ',
    time_remaining: 'ကျန်သောအချိန်',
    deposit_from_this_account_only: '⚠️ ဤအကောင့်မှသာ ငွေထည့်ပါ ⚠️',
    auto_credit_adjustment_warning: 'အလိုအလျောက် ခရက်ဒစ်ညှိခြင်းစနစ် မှန်ကန်သော ဒသမကိန်းငွေထည့်မှုမှ ကျေးဇူးပြု၍ ပတ်လည်မလုပ်ပါနှင့်',
    // Promotion texts
    select_receive_promotion: 'ပရိုမိုရှင်း ရယူရန် ရွေးပါ',
    no_promotion: 'ပရိုမိုရှင်း မရယူ',
    receive: 'ရယူရန်',
    not_receive: 'မရယူ',
    baht_unit: 'ကျပ်',
    // Menu and dialog texts
    logout_confirmation: 'စိစ္တမ်းကို ထွက်ရန်လား?',
    login_with_line: 'LINE မှာ ငောက်ရန်',
    use_coupon: 'ကုပောင် အစုမ်ပြု',
    play_through_app: 'အာပြှဲ ကစားရန်',
    loading_bank_data: 'ဘဏ်အချိန် ဖွင့်နေသည်...',
    no_deposit_channel: 'ဆာရက်ကာလ ငွေထည့်ကြင့်း မရှိ',
    bank_closed_service: 'စာရက်ကာလမှာ ဘဏ်စရဗိစာ ပိတ်သိ',
    service_hours: 'စရဗိစာ အချိန်',
    truewallet_24hrs: 'Truewallet: 24 နာရီ',
    try_again: 'ပြန်ကြိုးစား',
    // Skip option with bank name
    skip_use_first_account: 'ကျော်သွား (ပထမအကောင့် အစုမ်ပြု)',
    // Alt texts for images
    funbeyond_main_alt: 'Funbeyond အောင်လိင် ကစားချန်း ဘာကာရာ ကိခ်ခုမ် ကယားစာ အမွဲအမြု့',
    rewards_exchange_alt: 'PUG888 ဆုကြေားမြား မလည့်ယူ',
    play_game_alt: 'ကစားရန်',
    // Promotion texts
    bonus_2_percent_deposit: 'ငွေထည့်လွီင့်း 2% အမွဲ ရကောင့်',
    // Additional UI texts
    use_first_account: 'ပထမအကောင့် အစုမ်ပြု',
    no_deposit_channel_available: 'ဆာရက်ကာလ ငွေထည့်ကြင့်း မရှိ',
    bank_closed_now: 'ဘဏ်စရဗိစာ ပိတ်သိ',
    details: 'ပရိလှေတွက်',
    // Promotion terms
    terms: 'ဖြင့်မွားချက်',
    promotion_terms_title: 'ပရိုမိုရှင်း ဖြင့်မွားချက်',
    promotion_terms_message: 'ပရိုမိုရှင်း ရယူလိပါနေး ငွေထည့်မလွှေပြောင်း မမရှည်း ကြိုန့်ရယူပါ\n\n▪️ကျရသီတ် 5 ကျပ် အောက်မှာ ပရိုမိုရှင်း ရယူနိုင်\n▪️ပရိုမိုရှင်း ဖြင့်မွားချက် ဖလုပြုလှက် ဘိုနာစ် သွားမှု\n▪️နာပ်တန့် ဗဝေတားဖြင့် တဝေ့ရှိလှက် ကျရသီတ် နွုတ်ထား',
    acknowledge: 'အတည်ပြု',
    acknowledged_status: 'အတည်ပြုပြီး',
    thai_lang: 'ထိုင်း',
    // PromptPay messages
    promptpay_deposit_title: 'PromptPay ငွေထည့်အကြောင်း',
    amount_must_exceed_300: 'ပမာဏ 300 ကျပ် ထက် ပိုရမည်',
    promptpay_problem: 'PromptPay ငွေထည့်ပြဿနာ',
    please_contact_admin: 'ကျေးဇူးပြု၍ အက်ဒမင် ဆက်သွယ်ပါ',
    promptpay_success: 'PromptPay ငွေထည့်အောင်မြင်',
    // Promotion terms info
    promotion_terms_info: 'ပရိုမိုရှင်းအတွက် အရေးကြီးသောအချက်များ',
    promotion_term_1: 'ပရိုမိုရှင်း ရယူနိုင်သည် ခရက်ဒစ် ၁၀ ကျပ်အောက် ရှိသောအခါ',
    promotion_term_2: 'ပရိုမိုရှင်း စည်းမျဉ်းချိုးဖောက်ပါက ဘိုနပ်စ်နှင့် ကစားခွင့်ပြန်ရုတ်သိမ်း',
    promotion_term_3: 'ပုံမှန်မဟုတ်သော လောင်းကစားတွေ့ရှိပါက အကောင့်ပိတ်၍ ခရက်ဒစ်အားလုံးရုတ်သိမ်း',
    rewards_page: {
      title: 'Funbeyond တွင် ဆုကြေးများစွာ လဲလှယ်နိုင်ပါသည်',
      description: 'ခရက်ဒစ် 5 ကျပ်အောက် ရှိသောအခါ လဲလှယ်နိုင်သည်။<br>ဂိမ်းနှင့် ကာစီနို အတွက်သာ အသုံးပြုနိုင်သည် (အားကစား၊ ထီ မကစားရ)<br>UFA တွင် မကစားရ<br>စလော့ဂိမ်းများတွင် အင်္ဂါရပ်များ မဝယ်ရ (အခမဲ့စပင်များ)<br>3 ဆလည်ပတ်ပြီး ထုတ်ယူနိုင်သည်၊ အများဆုံး 5 ဆ ထုတ်ယူနိုင်သည်<br>ဘောနပ်စ်ကို ငွေအဖြစ် ထုတ်ယူ၍မရပါ၊ ငွေထုတ်တောင်းဆိုချိန်တွင် နုတ်ယူပါမည်<br>ခရက်ဒစ် 5 ကျပ်အောက် ရှိသောအခါ စည်းကမ်းချက်များ ပြီးဆုံးသည်။',
      subtitle: 'ထိပ်တန်းကာစီနို၊ နာမည်ကြီးဘရန်များ၊ အားလုံးရှိ - အလွယ်ထည့်၊ မြန်ထုတ်',
      footer_description: 'အကောင်းဆုံးဘရန်များနှင့် ကာစီနိုဂိမ်းများအားလုံးကို တနေရာတည်းတွင် UFA၊ IMI၊ EDMBET၊ Betflix - FunBeyond မိသားစုအတွက်သာ',
      detail: '{name} အကြွေစေ့များဖြင့် ဂိမ်းနှင့် ကာစီနို အတွက်သာ ကစားလိုပါသလား?\n{turn} ဆ လည်ပတ်ရမည်၊ အများဆုံး {maxwithdraw} ဆ ထုတ်ယူနိုင်သည်\nဘောနပ်စ်ကို ထုတ်ယူ၍မရပါ',
      confirm: 'အတည်ပြုရန်',
      cancel: 'ပယ်ဖျက်ရန်',
      warning: 'လက်ကျန်ငွေ 5 ကျပ်ထက် ပိုနေသောကြောင့် ခရက်ဒစ်လဲလှယ်၍မရပါ',
      warning2: 'သင့်တွင် 5 ကျပ်ထက် ပိုသော ခရက်ဒစ်ရှိသောကြောင့် မလုပ်ဆောင်နိုင်ပါ!',
      title2: 'ခရက်ဒစ် လဲလှယ်ရန်',
      locked_message: 'အရည်အချင်း မပြည့်မီ',
      your_points: 'သင့်ရမှတ်များ'
    },
    play_page: {
      alert_maintenance: 'စနစ်ပြုပြင်ထိန်းသိမ်းမှု'
    },
    partner_page: {
      hero_description: 'လင့်ခ်ကိုမျှဝေပြီး ကန့်သတ်ချက်မရှိ ဝင်ငွေရယူပါ',
      promotion_label: 'ပရိုမိုးရှင်း',
      alert_title: 'စည်းကမ်းများ',
      alert_credit_limit: 'ခရက်ဒစ် ၁၀ ကျပ်ထက် နည်းမှသာ လက်ခံရယူနိုင်ပါမည်',
      level1_title: 'မိတ်ဆွေများကို မိတ်ဆက်ပါ',
      level2_title: 'မိတ်ဆွေများက မိတ်ဆွေများကို မိတ်ဆက်သည်'
    },
    cashback_page: {
      hero_description: 'သင်၏ ကစားမှုပမာဏမှ နေ့စဉ် ငွေပြန်အမ်းရယူပါ!',
      info_title: 'ငွေပြန်အမ်း စည်းကမ်းချက်များ'
    },
    history_page: {
      hero_description: 'ငွေသွင်း-ထုတ်မှတ်တမ်းနှင့် ဘောနပ်စ်အားလုံး',
      summary_label: 'မှတ်တမ်းများ',
      empty_subtext: 'ငွေလွှဲပြောင်းမှုပြုလုပ်ပြီးပါက မှတ်တမ်းများကို ဤနေရာတွင် တွေ့ရပါမည်',
      status_success: 'အောင်မြင်သည်',
      status_cancelled: 'ပယ်ဖျက်သည်',
      status_pending: 'ဆောင်ရွက်နေသည်',
      type_deposit: 'ငွေသွင်း',
      type_withdraw: 'ငွေထုတ်',
      type_wheel: 'ဘီးလှည့်',
      type_roulette: 'ကစားနည်း',
      type_continue: 'ဆက်တိုက်ငွေသွင်း',
      type_referral: 'မိတ်ဆက်ခြင်း',
      type_cashback: 'ငွေပြန်အမ်း'
    }
  }
}

const supportedLocales = ['th', 'en', 'my']

function getInitialLocale () {
  try {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}')
    return supportedLocales.includes(userData.language) ? userData.language : 'th'
  } catch (error) {
    return 'th'
  }
}

const i18n = new VueI18n({
  locale: getInitialLocale(), // ภาษาเริ่มต้น
  fallbackLocale: 'th', // ภาษาสำรองถ้าไม่พบคำแปล
  messages
})

export default i18n
